import React, { Component } from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Right from '../../right/Right';
import './MealPlanner.css';
import { fetchInitialData2 } from "../../fetchData";
import Service from '../../service/Service';
import * as actions from './actions';
import Cookies from "js-cookie";
import MealRecipe from "./common/MealRecipe";
import UploadImgOverlay from './common/UploadImgOverlay';
import FooterMenu from "./common/FooterMenu";
import withContext from "../../../withContext";

const service = new Service();

class MealPlannerLanding extends Component {
    constructor(props) {
        super(props);
        let initialData = [];
        let mealRecpData = [];
        let mealSelRecp = [];
        let feedProfile = [];
        let sliderData = [];
        let articleData = [];
        let currentWeek = [];
        let selArticle = [];
        let serverSideData = {};
        let isApp='';
        let nonlogintext = 'Please login to get more personalized Meal Plan from 8 months till 24 months of your kid';

        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            serverSideData = window.__initialData__['initialData'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];
            }
        }
        if(serverSideData && serverSideData['data1'] && serverSideData['data1']['msg']==1 && serverSideData['data2'] && serverSideData['data2']['msg']==1){           
            if (serverSideData['data1'] && serverSideData['data1']['result']['childBreakfastObj']) {
                initialData = serverSideData['data1'];
                mealRecpData = serverSideData['data1']['result'];
                mealSelRecp = serverSideData['data1']['result']['childBreakfastObj'];
            }
            if( serverSideData['data1'] && serverSideData['data1']['result']['childArr']){
                feedProfile = serverSideData['data1']['result']['childArr'];
            }
            if( serverSideData['data1'] && serverSideData['data1']['result']['totalweek']){
                currentWeek = serverSideData['data1']['result']['totalweek'];
            }
            if (serverSideData['data2'] && serverSideData['data2']['result']) {
                articleData = serverSideData['data2']['result'];
                selArticle = serverSideData['data2']['result'][8];
            }

        }
        if (this.props.location.search.includes('from=app')) {
            isApp=true;
        }
        if(currentWeek==0){
            currentWeek=1;
        }
        // if (__isBrowser__ && Cookies.get('isMealPageRefresh') == '1') {
        //     Cookies.set("isMealPageRefresh", '', { expires: -1, domain: '.firstcry.com' });
        //     Cookies.set("isMealPageRefresh", '');
        //     location.reload();
        // }
        // console.log("mealRecpData========>", serverSideData, currentWeek);
        this.state = {
            metaTitle: "Personalized Baby & Toddlers Meal Plans with Recipies | FirstCry Parenting ",
            metaDescription: [  { "name": "description", "content": "FirstCry Parenting’s Baby Meal Planner is an ideal tool to create perfect personalized meal plans for your child (8 to 24 Months)." },
            { "name": "keywords", "content": "Baby meal planner, baby food planner" },
            { "name": "atdlayout", "content": "" }],
            initialData: initialData,
            mealRecpData: mealRecpData,
            currentWeek: currentWeek,
            feedProfile: feedProfile,
            mealSelRecp:mealSelRecp,
            selected_child_id: '',
            expertInfo:{
                gender: ''
            },
            childName:'',
            childGender: '',
            sliderData: sliderData,
            cropedImagePath: '',
            articleData: articleData,
            uploadedSrc: '',
            babyAge: '',
            recipes: '',
            isMemorySelected: false,
            isApp: isApp,
            tncAgree: false,
            selArticle: selArticle,
            nonlogintext: nonlogintext,
            welComeMsg: mealRecpData && mealRecpData.recMsg,
            userName : mealRecpData && mealRecpData.userName
        };
        this.isJcropFilesLoaded = false;
        this.timeout = 0;
    }
    static initialAction(reqUrl, ftk, authData, uId, childData, cookieData) {
        console.log("initialAction ** ", cookieData);
        // debugger;
        var LatestFtk = '';
        if (cookieData && (cookieData.includes("app_ftk"))) {
        var cookieAry = cookieData.split(';');
            for (var i = 0; i < cookieAry.length; i++) {
                if (cookieAry[i] && cookieAry[i].includes("app_ftk")) {
                LatestFtk = cookieAry[i].split('app_ftk=')[1];
                }         
            }         
        }
        console.log("LatestFtk=====>",LatestFtk);
        let childinfo = childData['UserChildList'];
        let postdietarr = [];
        if (childinfo) {
            postdietarr = childData['UserChildList'];
        } else {
            postdietarr = [];
        }
        if (postdietarr.length > 1) {
            if (postdietarr[0]['IsExpected']) {
                childinfo = [{
                    "childid": postdietarr[1]['ChildId'],
                    "childname": postdietarr[1]['ChildName'],
                    "dob": postdietarr[1]['DOB'],
                    "childgender": postdietarr[1]['Gender'],
                    "childphoto": postdietarr[1]['childPhoto']
                }];
            } else {
                childinfo = [{
                    "childid": postdietarr[0]['ChildId'],
                    "childname": postdietarr[0]['ChildName'],
                    "dob": postdietarr[0]['DOB'],
                    "childgender": postdietarr[0]['Gender'],
                    "childphoto": postdietarr[0]['childPhoto']
                }];
            }
        }
        else if (postdietarr.length == 1) {
            if (postdietarr[0]['IsExpected']) {
                childinfo = [];
            } else {
                childinfo = [{
                    "childid": postdietarr[0]['ChildId'],
                    "childname": postdietarr[0]['ChildName'],
                    "dob": postdietarr[0]['DOB'],
                    "childgender": postdietarr[0]['Gender'],
                    "childphoto": postdietarr[0]['childPhoto']
                }];
            }
        }  
        console.log("childinfo ===>",childinfo)      
        var header = {
            'Content-Type': 'application/json',
            'ftk': (ftk!="")?ftk:LatestFtk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        let postData = [];
        
        if(ftk){
            postData={
                "isToggleSet":1
            };
        }
        else{
            postData={
                "isToggleSet":1
            }
        }
        let obj1 = {
            url: global.api_url + "dietplan/gethomerecpage",
            body: JSON.stringify({"isToggleSet":1})
        };
        let obj2 = {
            // url: global.api_url + "dietplan/getdietplansummaryweek",
            url : "http://community.fcappservices.in/dietplan/getdietplansummaryweek",
            body: JSON.stringify({
                "childinfo": childinfo,
                "pageNo": 1,
                "pageSize": 10,
                "stageid": ""
            })
        };
        // console.log(header);
        // console.log("obj1----------->>>>>>>", obj1);
        // console.log("obj2----------->>>>>>>", obj2);
        return fetchInitialData2(obj1, obj2, JSON.stringify(header));
   
    }
    componentDidMount() {
        this.setState({ windowWidth: window.outerWidth});
        // console.log("initialData========>", this.state.initialData);
        // console.log("feedProfile========>", this.state.feedProfile);
        // console.log("currentWeek========>", this.state.currentWeek);
        // console.log("mealSelRecp========>", this.state.mealSelRecp);
        // console.log("mealRecpData========>", this.state.mealRecpData);
        // console.log("this.state.selArticle====================>",this.state.selArticle);
        // var arrayval=Object.arrayval(this.state.mealSelRecp);
        if (this.state.isApp) {
            actions.loadCallbackFile();
            // document.querySelector('.disclaimer-con').style.paddingBottom="33px";
            document.querySelector('.sub-container').style.marginBottom="0";
            document.querySelector('.footerList').style.bottom="0px";
            document.querySelector('.disclaimer-con').style.marginBottom="0";
            document.querySelector(".main-container").style.width = "auto";
            document.querySelector(".article-cont")!=null && document.querySelector(".card_title")!=null && (document.querySelector(".meal-planner .article-cont .card_title").style.letterSpacing = "0.02em");
            
        }

        if(document.querySelector('.child-prof-list') && document.querySelector('.ChilProf')){
            document.querySelector('.child-prof-list').style.width=document.querySelectorAll('.ChilProf').length*112+15+"px";
        }

        document.addEventListener("click", this.domClick);
        if (navigator.onLine) {
            if(!this.state.articleData || (this.state.articleData && Object.keys(this.state.articleData).length < 1))
            {
                service.showLoader();
                this.getDietplanBabyData();

            }else{
                localStorage.setItem('DietplanBabyData', JSON.stringify(this.state.articleData));
            }
            if (!this.state.initialData || (this.state.initialData && Object.keys(this.state.initialData).length < 1)){
                this.feedProfile("onLoad","",1);
                service.showLoader();
            } else {
                localStorage.setItem('feedProfile', JSON.stringify(this.state.initialData));
                // actions.loadReadMore();
            }

        } else {
            if (localStorage.getItem('feedProfile')) {
                this.setState({
                    initialData: JSON.parse(localStorage.getItem('feedProfile')),
                    mealRecpData: JSON.parse(localStorage.getItem('feedProfile'))['result'],
                    feedProfile: JSON.parse(localStorage.getItem('feedProfile'))['result']['childArr'],
                    currentWeek: JSON.parse(localStorage.getItem('feedProfile'))['result']['totalweek']
                }, () => { service.loadImages(); });
            }
            if(localStorage.getItem('DietplanBabyData')) {
                this.setState({ articleData: JSON.parse(localStorage.getItem('DietplanBabyData')),selArticle: JSON.parse(localStorage.getItem('DietplanBabyData'))[8] }, () => { service.loadImages(); });
            }
            service.hideLoader();
        }
        if(this.state.mealRecpData.childid == '' || !this.state.mealRecpData.childid){
            // document.querySelector('.more-info') && (document.querySelector('.welbottom').style.bottom="51px");
            document.querySelector('.welbottom') && (document.querySelector('.welbottom').style.bottom="51px");
        }
        this.loadData();
        // console.log("windowWidth--", window.outerWidth);
       
    }
    // convertHtml2Canvas() {
    //     var _this = this;
    //     var node = document.querySelector('#screenShot_1');
    //     domtoimage.toPng(node)
    //         .then(function (dataUrl) {
    //             var img = new Image();
    //             img.src = dataUrl;
    //             var a=document.body.appendChild(img);
    //             console.log("image====>",img.src);
    //             console.log("image====>",a);
    //             var file_name = Math.round(new Date().getTime() / 1000) + ".jpg";
    //             _this.file = actions.dataURItoFileFB(img.src, file_name);
    //             _this.uploadCertificate(_this.file, "");
    //         })
    //         .catch(function (error) {
    //             console.error('oops, something went wrong!', error);
    //         });
    // }
    // convertHtml2Canvas() {
    //     var _this = this;
    //     var dataURL;
    //     dataURL = new Image();
    //     dataURL.crossOrigin = "Anonymous";
    //     dataURL.allowTaint = true;
    //     dataURL.src = document.getElementById('screenShot_1').getElementsByTagName('img')[0].src;
    //     dataURL.width = 300;
    //     dataURL.height = 300;
    //     var cerEle = document.getElementById('screenShot_1');
    //     dataURL.onload = function () {
    //         html2canvas(cerEle, {
    //             useCORS: true,
    //             onrendered: function (canvas) {
    //                 var imgurl = canvas.toDataURL();
    //                 var file_name = Math.round(new Date().getTime() / 1000) + ".jpg";
    //                 _this.file = actions.dataURItoFileFB(imgurl, file_name);
    //                 // ********** for upload certificate on cdn ********** //
    //                 _this.uploadCertificate(_this.file, "");
    //                 // ********** for displaying certificate for testing ********** //
    //                 // var url = URL.createObjectURL(_this.file);
    //                 // document.getElementById('test-image').getElementsByTagName('img')[0].src = url;
    //                 // document.getElementById('test-image').style.display = "block";
    //             }
    //         });
    //     }
    // }
    
    // uploadCertificate(file, type) {
    //     // service.showLoader();
    //     var file_name = Math.round(new Date().getTime() / 1000) + "_" + file.name;
    //     var apiurl = global.api_ci_url + "Parenting/uploadMemoryImage";
    //     service.postFileServiceCall(apiurl, file, file_name).then((json) => {
    //         console.log(json);
    //         window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(global.currentURL) + '&t=' + encodeURIComponent(json.image_url));
    //         if (json["result"] == 'success') {
    //             // if (json.image_url) {
    //             //     this.setState({ isCerUploaded: true, uploadedCerSrc: json.image_url });
    //             // }
    //             // if (this.isShareClicked) {
    //             //     this.shareCertificate(true);
    //             // }
    //         }
    //         service.hideLoader();
    //     }).catch((error) => {
    //         console.error(error);
    //         service.hideLoader();
    //     });
    // }
    getDietplanBabyData() {
        var childListData = global.userAry['childData']['UserChildList'];
        var selectchildName,selectedChild;
        if (childListData) {
            if (childListData.length > 1) {
                if (childListData[0]['IsExpected']) {
                    selectchildName = childListData[1]['ChildName'];
                    selectedChild = childListData[1]['ChildId'];
                } else {
                    selectchildName = childListData[0]['ChildName'];
                    selectedChild = childListData[0]['ChildId'];
                }
            } else if (childListData.length == 1) {
                if (childListData[0]['IsExpected']) {
                    selectchildName = '';
                    selectedChild = '';
                } else {
                    selectchildName = childListData[0]['ChildName'];
                    selectedChild = childListData[0]['ChildId'];
                }
            } else {
                selectchildName = '';
                selectedChild = '';
            }
        }
        let childinfo = childListData;
        let childname,dob,childgender,childphoto;
        if(selectedChild && childListData){
            // console.log("selectChild=====>",selectedChild)
                for (let i = 0; i < childListData.length; i++) {
                    if (childListData[i]['ChildId'] == selectedChild) {
                        childgender = childListData[i]['Gender'];
                        dob = childListData[i]['DOB'];
                        childname = childListData[i]['ChildName'];
                        childphoto = childListData[i]['childPhoto'];
                    }
                }
                childinfo = [{
                "childid": selectedChild,
                "childgender": childgender,
                "dob": dob,
                "childname": childname,
                "childphoto": childphoto
            }];
        }else{
            childinfo = [{
                "childid": '',
                "childgender": '',
                "dob": '',
                "childname": '',
                "childphoto": ''
            }];
        }
        var postData = {
            "childinfo": childinfo,
            "pageNo": 1,
            "pageSize": 10,
            "stageid": ""
        };
        // var url = global.api_ci_url + "DietplanBaby/getDietplanBabyData";
        var url = global.api_url + "dietplan/getdietplansummaryweek";
        service.postServiceCall(url, postData).then((json) => {
            if (json['result']) {
                this.setState({
                    articleData: json['result'],
                    selArticle: json['result'][8]
                }, () => { service.loadImages(); });
                localStorage.setItem('DietplanBabyData', JSON.stringify(json['result']));
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    feedProfile(flag,childID,isToggleSet) {
        if(flag=="selectChild" || flag=="toggleSet"){
            var postData = {
                "isToggleSet": isToggleSet,
                "childid": childID
            };
        }else{
            var postData = {
                "isToggleSet": 1
            };
        }
        // var url = global.api_url + "dietplan/gethomerecpage";
        var url = global.api_ci_url + "MealPlanner/getHomerecipe";
        service.postServiceCall(url, postData).then((json) => {
            // console.log("select result=======>",json);
            if (json['msg'] == "1") {
                if(flag=="toggleSet"){
                    if(isToggleSet==0){
                        document.querySelector(".online-toggle").classList.add("show-non-veg");
                        document.querySelector(".veg-only").style.display="none";
                        document.querySelector(".non-veg-only").style.display="block";
                    }else{
                        document.querySelector(".online-toggle").classList.remove("show-non-veg");
                        document.querySelector(".veg-only").style.display="block";
                        document.querySelector(".non-veg-only").style.display="none";
                    }
                }
                if(json['result']['totalweek']==0){
                   var currentWk=1;
                }else{
                   var currentWk= (json['result']['totalweek'] && parseInt(json['result']['totalweek']))?json['result']['totalweek']:1;
                }
                this.setState({  mealRecpData: json['result'], initialData:json, currentWeek:currentWk, feedProfile:json['result']['childArr'] }, () => {
                    service.loadImages();
                    this.loadData();
                    service.hideLoader();
                });
            } else {
                service.hideLoader();
            }
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    loadData(){
        // console.log("saveNewChildData",localStorage.getItem('saveNewChildData'));
        console.log("global.userAry['EmailAddress'] ==>", global.userAry['EmailAddress'])
        console.log("global.userAry['mobileno'] ==>", global.userAry['mobileno'])
        if(global.ftk != ''){
        Cookies.set("mealLogin",global.userAry['EmailAddress'].trim());
        }
        if(localStorage.getItem('saveNewChildData') && localStorage.getItem('saveNewChildData')!=''){
            var postData=localStorage.getItem('saveNewChildData');
            
            const dobString = JSON.parse(postData).DOB; // "26-Nov-2021"
            const dob = new Date(dobString); // Convert string to Date object
            const today = new Date(); // Current date


            // Calculate the age
            const age = this.calculateAge(dob, today);
            const ageRange = this.getAgeRange(age);

            let ageString = "";
            if (age.years > 0) {
                ageString += `${age.years} year${age.years > 1 ? "s" : ""}`;
                if (age.months > 0) {
                    ageString += ` ${age.months} month${age.months > 1 ? "s" : ""}`;
                }
            } else if (age.months > 0) {
                ageString += `${age.months} month${age.months > 1 ? "s" : ""}`;
                if (age.days > 0) {
                    ageString += ` ${age.days} day${age.days > 1 ? "s" : ""}`;
                }
            } else {
                ageString += `${age.days} day${age.days > 1 ? "s" : ""}`;
            }

            var url = global.api_ci_url + "MealPlanner/insertChildInformation";
            service.postServiceCall(url, postData).then((json) => {
                if (json['InsertChildDetails']) {
                    // console.log("InsertChildDetails:", json['InsertChildDetails']);
                    document.getElementsByClassName("childProfile_overlay1")[0].style.display = 'none';
                    document.querySelector('body').style.overflow="visible";
                    if(this.state.isApp){
                        let appMXPJson = {
                            "appurl": [
                                {
                                  "pagetype": "addchild",
                                  "childobj": {
                                    "childid": json['InsertChildDetails'],
                                    "childname": JSON.parse(postData).ChildName,
                                    "dob": JSON.parse(postData).DOB,
                                    "childgender": JSON.parse(postData).Gender,
                                    "ageRange": ageRange,
                                    "age": ageString,
                                    "childImageUrl": JSON.parse(postData).childPhoto,
                                    "selected": false,
                                    "isExpected": false,
                                    "ageid": ""
                                  }
                                }
                              ]
                            }; 
                            service.jsontracker(JSON.stringify(appMXPJson));
                    }

                    localStorage.setItem('saveNewChildData','');
                    // console.log("saveNewChildData",localStorage.getItem('saveNewChildData'));

                    window.location.href= service.getRedirectUrl("/tools/baby-meal-plan");
                    // this.onLoad();

                }
                service.hideLoader();
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
        }else{
            this.onLoad(); 
        }

    }

    getAgeRange(age) {
        if (age.years === 0 && age.months < 24) {
            return "Baby";
        } else if (age.years >= 2 && age.years < 4) {
            return "Toddler";
        } else if (age.years >= 4) {
            return "Kid";
        }
        return "Baby"; // Default for cases under 2 years
    }

    calculateAge(dob, today) {
        let years = today.getFullYear() - dob.getFullYear();
        let months = today.getMonth() - dob.getMonth();
        let days = today.getDate() - dob.getDate();
    
        // Adjust months and years if necessary
        if (days < 0) {
            months--;
            days += new Date(today.getFullYear(), today.getMonth(), 0).getDate();
        }
        if (months < 0) {
            years--;
            months += 12;
        }
    
        // Return the age in a structured format
        return {
            years: years,
            months: months,
            days: days
        };
    }


    onLoad(){
        var childId = "";
        let babyAge=[];
        if(this.state.mealRecpData && this.state.mealRecpData.recMsg && global.ftk){
            document.querySelector(".welcometxt2") && (document.querySelector(".welcometxt2").innerHTML=this.state.mealRecpData.recMsg);
            var welComeMag=document.querySelector(".welcometxt2").innerHTML.replace(/&nbsp;/g, ' ');
            this.setState({welComeMsg:welComeMag});
        }
        if (global.ftk && this.state.feedProfile != null && this.state.feedProfile.length > 0) {
            if(this.state.mealRecpData.childid){
                for(var i=0;i<this.state.feedProfile.length;i++){
                    if(this.state.mealRecpData.childid==this.state.feedProfile[i].childId){
                        var month = this.state.feedProfile[i].age.month + " Months ";
                        var week = this.state.feedProfile[i].age.week + " Week ";
                        var year = this.state.feedProfile[i].age.year + " Year ";
                        var day = this.state.feedProfile[i].age.day + " days ";
                            if(this.state.feedProfile[i].age.year!=0){
                                babyAge.push(year);
                            }
                            if(this.state.feedProfile[i].age.month){
                                babyAge.push(month);
                            }
                            if(this.state.feedProfile[i].age.week){
                                babyAge.push(week);
                            }
                            if(this.state.feedProfile[i].age.day!=0){
                                babyAge.push("and "+ day);
                            }
                            Cookies.set("childPhoto",this.state.feedProfile[i].childPhoto);
                            var childgender = this.state.feedProfile[i].gender && this.state.feedProfile[i].gender.charAt(0) && (this.state.feedProfile[i].gender.charAt(0).toUpperCase() + this.state.feedProfile[i].gender.substr(1).toLowerCase());
                            this.setState({childgender:childgender});
                        }
                    }
                Cookies.set("babyAge",babyAge);
                childId=this.state.mealRecpData.childid;
                this.setState({babyAge:babyAge});
            }else{
                childId = this.state.selected_child_id;
            }
            this.setState({ selected_child_id: childId});
        }
        if(global.ftk && (childId !=0 && childId !='')){
            this.appendChildInfo(childId);  
            this.clickWeek(this.state.currentWeek);           
       }
       if(this.state.isApp){
        var obj={};
        obj.gaObj = ""
        obj.webengageObj = {
            "eventname": "diet_plan_tab_6months",
            "eventdata": {
            "diet_plan_tab_6months": "Yes",
            "diet_plan_tab":  "Yes",
            "scat_id": "",
            "cat_id": "",
            "selected_diet_plan_month": this.state.mealRecpData.currentMonth ? this.state.mealRecpData.currentMonth : "",
            "viewed": "Yes" 
            }
        }

        actions.trackEvent(obj);

        obj.webengageObj = {
            "eventname": "meal_planner_visited",
            "eventdata": {}
        }
        actions.trackEvent(obj);
       }
        this.selMealRecp(this.state.mealRecpData.isHighlight,"","onLoad");
    }
    domClick(event) {
        // console.log("event Dom========>",event.target)
        if (event.target.classList.contains('share-overlay')) {
            let ary = document.getElementsByClassName('sharing-options');
            for (let i = 0; i < ary.length; i++) {
                ary[i].style.display = 'none';
            }
            if (document.getElementsByClassName('share-overlay')[0]) {
                document.getElementsByClassName('share-overlay')[0].style.display = 'none';
            }
        }
        if(event.target.classList.contains('child-prof-overlay')){
            document.getElementsByClassName('child-prof-overlay')[0].style.display = 'none';
            document.querySelector('body').style.overflow = "visible";
        }
        if(event.target.classList.contains('childProfile_overlay2')){
            document.getElementsByClassName('childProfile_overlay2')[0].style.display = 'none';
            document.querySelector('body').style.overflow = "visible";
        }
        // if(event.target.classList.contains('mealPop-overlay')){
        //     document.getElementsByClassName('mealPop-overlay')[0].style.display = 'none';
        // }
        if(event.target.nextSibling && event.target.nextSibling.classList && event.target.nextSibling.classList.contains("textfield-label")){
            var list = document.querySelectorAll(".textfield-label");
            for(var i = 0; i<list.length; i++){
                list[i].classList.remove("focus-active");
            }
            event.target.nextSibling.classList.add("focus-active");
            if(document.querySelector('#select_child_upto2').value!=''){
                document.querySelector('#select_child_upto2').nextSibling.classList.add('focus-active');
            }
        }
        if(event.target.classList.contains('alertMsg-overlay')){
            document.getElementsByClassName('alertMsg-overlay')[0].style.display = 'none';
        }
        if(event.target.classList.contains('childProfile_overlay1')){
            document.getElementsByClassName('childProfile_overlay1')[0].style.display = 'none';
            document.querySelector('body').style.overflow="visible";
        }
        // else{
        //     if(document.querySelector(".textfield-label") && document.querySelector(".textfield-label").classList.contains("focus-active")){
        //         var list = document.querySelectorAll(".textfield-label");
        //         for(var i = 0; i<list.length; i++){
        //             list[i].classList.remove("focus-active");
        //         }
        //         document.querySelector(".textfield-label").classList.remove("focus-active");
        //     }
        // }
    }
    // pageScroll(){
    //     var _this = this;
    //     clearTimeout(_this.timeout);
    //     _this.timeout = setTimeout(function () {
    //         if (document.getElementsByClassName('data-container')[0]) {
    //             var cS = document.getElementsByClassName('data-container')[0].offsetTop;
    //             if ((window.scrollY - cS) > 0) {
    //                 document.querySelector(".footerList").style.display="none";
    //                 document.getElementsByClassName('sub-container')[0].style.marginBottom="0px";
    //                 document.getElementsByClassName('disclaimer-con')[0].style.paddingBottom="0px";
    //             }else{
    //                 document.querySelector(".footerList").style.display="block";
    //                 document.getElementsByClassName('sub-container')[0].style.marginBottom="42px";
    //                 document.getElementsByClassName('disclaimer-con')[0].style.paddingBottom="33px";
    //             }
    //         }
    //     }, 100)
    // }
    // openMealPopupSlider(event, e){
    //     document.querySelector('.mp-slider').style.display = 'none';
    //     for(let i = 1; i < 4; i++){
    //         if(document.getElementById('mp-slider'+i).style.display == 'block'){
    //             document.getElementById('mp-slider'+i).style.display == 'none';
    //         }
    //     }
    //     if(e == 'up'){
    //         document.getElementById('mp-slider'+event).style.display = 'block';
    //         document.getElementById('mpup'+event).style.display = 'none';
    //         document.getElementById('mpdown'+event).style.display = 'block';
    //     }else{
    //         document.getElementById('mpdown'+event).style.display = 'none';
    //         document.getElementById('mp-slider'+event).style.display = 'none';
    //         document.getElementById('mpup'+event).style.display = 'block';
    //     }
    // }
    onEditChild(e){
        // console.log("e.target",e.target);
        if(document.querySelector('.childInfo_div')!=null){
            var id=document.querySelector('.childInfo_div').attributes['data-id'].textContent.split("_");
            var split1=id[2];
            if(split1 == this.state.selected_child_id){
                let chilProfCl= document.querySelectorAll('.ChilProf');
                for(var i=0;i<chilProfCl.length;i++){
                    if(chilProfCl[i].classList.contains('active')){
                        chilProfCl[i].classList.remove('active');
                    }
                }
                document.querySelector("#ChilProf_"+split1).classList.add('active');
            }
            document.getElementsByClassName('child-prof-overlay')[0].style.display = 'block';
            document.querySelector('body').style.overflow = "hidden";
        }

        if(this.state.isApp){
            let appGTMJson = {
                "appurl": [
                    {
                      "pagetype": "appGaEvent",
                      "EventType": "appGaEvent",
                      "gaEvent": "",
                      "gajsonEvent": {
                        "profile": "Baby 0 to 2 yrs",
                        "action_type": "edit"
                      },
                      "webengageEvent": {
                        "eventname": "bmp_hmpg_profile_actions",
                        "eventdata": {
                            "profile": "Baby 0 to 2 yrs",
                            "action_type": "edit",
                            "sendWithoutGtm": "yes"          //mixpanel event send without GTM
                        }
                      },
                      "jarvisEvent": {
                        "eventname": "bmp_hmpg_profile_actions",
                        "eventdata": {
                            "profile": "Baby 0 to 2 yrs",
                            "action_type": "edit"
                        }
                      }
                    }
                  ]
                }; 
                service.jsontracker(JSON.stringify(appGTMJson));
        }
    }
    appendChildInfo(childId) {

        if (global.ftk) {
            var selected_child_id = childId; 
            var childArr = this.state.feedProfile;
            var child_info = "";
            var idealrange = this.state.mealRecpData.idealrange;
            for (var i = 0; i < childArr.length; i++) {
                var center_circle_name;
                var slider_range, slider_min_range, slider_max_range, slider_active;
                if (childArr[i].isExpecting && childArr[i].isExpecting==1) {
                    center_circle_name = "Weeks";
                    slider_range = 40;
                    slider_min_range = 1;
                    slider_max_range = 40;
                    slider_active = parseInt(childArr[i].currentWeek);
                    slider_min_range = slider_active - 10 < 1 ? 1 : slider_active - 10;
                    slider_max_range = slider_active + 10 > slider_max_range ? slider_max_range : slider_active + 10;
                } else {
                    // if (childArr[i].age.year < 1) {
                    //     center_circle_name = "Days";
                    // } else
                    if (childArr[i].age.year < 2) {
                        center_circle_name = "Weeks";
                    } else if (childArr[i].age.year >= 2) {
                        center_circle_name = "Months";
                    }
                    // if (childArr[i].age.year == 0) {
                    //     slider_range = 365;
                    //     slider_min_range = 1;
                    //     slider_max_range = 365;
                    //     if (childArr[i].age.day == 0) {
                    //         slider_active = slider_min_range;
                    //     } else {
                    //         slider_active = this.diffBetDatesInDays(childArr[i].dob);
                    //     }
                    // } else
                     if (childArr[i].age.year < 2) {
                        slider_range = 76;
                        slider_min_range = slider_range * childArr[i].age.year;
                        slider_min_range = 1;

                        // slider_max_range = slider_range * (childArr[i].age.year + 1);
                        slider_max_range = 76;

                        // if (childArr[i].age.day == 0 && childArr[i].age.month == 0) {
                        //     slider_active = slider_min_range;
                        // } else {
                        //     slider_active = this.state.currentWeek;
                        // }
                        if(this.state.currentWeek==0){
                            slider_active = 1;
                        }else{
                            slider_active = this.state.currentWeek;
                        }
                    } else {
                        slider_range = 12;
                        slider_min_range = slider_range * childArr[i].age.year;
                        slider_max_range = slider_range * (childArr[i].age.year + 1);
                        slider_active = parseInt(childArr[i].age.year) * 12 + parseInt(childArr[i].age.month)
                    }
                    // slider_min_range = slider_active - 10 < 1 ? 1 : slider_active - 10;
                    // slider_max_range = slider_active + 10;
                }
                if (childArr[i]['childId'] == selected_child_id) {
                  
                    //show selected child's image 
                    Cookies.set("mealChild_id",childArr[i]['childId']);
                    Cookies.set("mealChildName",childArr[i]['childName']);
                    Cookies.set("mealChildMonth",this.state.mealRecpData.currentMonth);

                    if(document.querySelector('.expecting_default_img')){
                        if (childArr[i].childPhoto && childArr[i].isExpecting && childArr[i].isExpecting==1 ) {
                            document.querySelector('.expecting_default_img').src=childArr[i].childPhoto.replace("http://", "https://");
			}else if (!childArr[i].childPhoto && childArr[i].isExpecting && childArr[i].isExpecting==1) {
                            document.querySelector('.expecting_default_img').src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/mob_expecting.png';
			} else if (!childArr[i].childPhoto && !childArr[i].isExpecting && childArr[i].isExpecting==1) {                                        
                            document.querySelector('.expecting_default_img').src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/mob_baby.png';
                        } else {
                            document.querySelector('.expecting_default_img').src=childArr[i].childPhoto.replace("http://", "https://");
                        }
                    }
                    

                    const sliderData1 = [];
                    // const forloopslide1 = [];
                    // const forloopslide2 = [];
                    // const arrowsSlide = [];
                    // for (var j = (slider_min_range - 1); j < slider_max_range; j++) {
                    //     forloopslide1.push(
                    //         <div key={j}>
                    //             {(j + 1) == slider_active ?
                    //                 (
                    //                     <li key={j} className={'left weekNo days_' + ((j + 1) * (7)) + ' active'} rel={((j + 1) * (7))} onClick={(e) => { this.activeWeek(e,(j + 1)) }}>

                    //                         {window.innerWidth > 767 ? (
                    //                             <span className="week_cnt M14_white">{(j + 1)}</span>
                    //                         ) : (<span className="week_cnt M16_white">{(j + 1)}</span>)}
                    //                         <span className="active_week_name">{center_circle_name}</span>
                    //                     </li>)
                    //                 : (<li key={j} className={'left weekNo days_' + (j + 1) * (7)} rel={((j + 1) * (7))} onClick={(e) => { this.activeWeek(e,(j + 1)) }}>
                    //                     {window.innerWidth > 767 ? (
                    //                         <span className="week_cnt M14_white">{(j + 1)}</span>
                    //                     ) : (<span className="week_cnt R12_white">{(j + 1)}</span>)}
                    //                     <span className="active_week_name">{center_circle_name}</span>
                    //                 </li>)
                    //             }
                    //         </div>
                    //     );
                    // }
                    // for (var k = (slider_min_range - 1); k < slider_max_range; k++) {
                    //     forloopslide2.push(
                    //         childArr[i].age.year < 2 ?

                    //             (<div key={k}>
                    //                 {(k + 1) == slider_active ?
                    //                     (
                    //                         <li key={k} className={'left weekNo active days_' + (k + 1)} rel={(k + 1)} onClick={(e) => { this.activeWeek(e, (k + 1)) }}>

                    //                             {window.innerWidth > 767 ? (
                    //                                 <span className="week_cnt M14_white">{(k + 1)}</span>
                    //                             ) : (<span className="week_cnt M16_white">{(k + 1)}</span>)}
                    //                             <span className="active_week_name">{center_circle_name}</span>
                    //                         </li>)
                    //                     : (<li key={k} className={'left weekNo days_' + (k + 1)} rel={(k + 1)} onClick={(e) => { this.activeWeek(e, (k + 1)) }}>
                    //                         {window.innerWidth > 767 ? (
                    //                             <span className="week_cnt M14_white">{(k + 1)}</span>
                    //                         ) : (<span className="week_cnt R12_white">{(k + 1)}</span>)}
                    //                         <span className="active_week_name">{center_circle_name}</span>
                    //                     </li>)
                    //                 }
                    //             </div>) : (
                    //                 (k + 1) == slider_active ?
                    //                     (
                    //                         <li key={k} className={'left weekNo active days_'((k + 1) * (30))} rel={((k + 1) * (30))} onClick={(e) => { this.activeWeek(e, (k + 1)) }}>

                    //                             {window.innerWidth > 767 ? (
                    //                                 <span className="week_cnt M14_white">{(k + 1)}</span>
                    //                             ) : (<span className="week_cnt M16_white">{(k + 1)}</span>)}
                    //                             <span className="active_week_name">{center_circle_name}</span>
                    //                         </li>)
                    //                     : (<li key={k} className={'left weekNo days_' + ((k + 1) * (30))} rel={((k + 1) * (30))} onClick={(e) => { this.activeWeek(e,(k + 1)) }}>
                    //                         {window.innerWidth > 767 ? (
                    //                             <span className="week_cnt M14_white">{(k + 1)}</span>
                    //                         ) : (<span className="week_cnt R12_white">{(k + 1)}</span>)}
                    //                         <span className="active_week_name">{center_circle_name}</span>
                    //                     </li>)
                    //             )
                    //     );
                    // }

                    // arrowsSlide.push(
                    //     <div key={i}>
                    //         <div className="arrows">
                    //             <span className="next" onClick={(e)=>{this.slideDays(e)}}>
                    //                 <span data-icon-font="h" className="icon dev_next"></span>
                    //             </span>
                    //             <span className="prev" onClick={(e)=>{this.slideDays(e)}}>
                    //                 <span data-icon-font="g" className="icon dev_prev"></span>
                    //             </span>
                    //         </div>
                    //         <div className="horizontal_line"></div>
                    //     </div>
                    // );
                    sliderData1.push(
                        <div key={i}>
                            <div className="childInfo_div" data-id={'current_child_' + selected_child_id}>
                                <div className="left height_block">
                                    {idealrange && 
                                        <div>
                                            <div className="R10_9e">Ideal Height</div>
                                            <div className="M12_42"> {idealrange.minht} CM</div>
                                            <div className="R10_61 heighttitle">{childArr[i].childName && childArr[i].childName.charAt(0).toUpperCase() + childArr[i].childName.substr(1).toLowerCase()} Height</div>
                                            {this.state.isApp ?
                                            <a onClick={()=>{this.growthAppCall("ht")}}>
                                                 <div className="M12_42 heightval">{this.state.mealRecpData && this.state.mealRecpData.childHeight ? parseFloat(this.state.mealRecpData.childHeight):'0'} CM</div>
                                            </a>
                                        :
                                        <a href={"https://parenting.firstcry.com/tools/child-vaccination-growth-tracker/childgraph/"+childArr[i].childId}>
                                            <div className="M12_42 heightval">{this.state.mealRecpData && this.state.mealRecpData.childHeight ? parseFloat(this.state.mealRecpData.childHeight):'0'} CM</div>
                                        </a>
                                        }
                                        
                                        </div>
                                    }
                                </div>
                                <div className="right weight_block">
                                    {idealrange &&
                                        <div>
                                            <div className="R10_9e">Ideal Weight</div>
                                            <div className="M12_42">{idealrange.minwt} KG</div>
                                            <div className="R10_61 weigttitle">{childArr[i].childName && childArr[i].childName.charAt(0).toUpperCase() + childArr[i].childName.substr(1).toLowerCase()} Weight</div>
                                            {this.state.isApp ?
                                            <a onClick={()=>{this.growthAppCall("wt")}}>
                                                 <div className="M12_42 weightval">{this.state.mealRecpData && this.state.mealRecpData.childWeight ? parseFloat(this.state.mealRecpData.childWeight):'0'} KG</div>
                                            </a>
                                        :
                                        <a href={"https://parenting.firstcry.com/tools/child-vaccination-growth-tracker/childgraph/"+childArr[i].childId}>
                                            <div className="M12_42 weightval">{this.state.mealRecpData && this.state.mealRecpData.childWeight ?parseFloat(this.state.mealRecpData.childWeight):'0'} KG</div>
                                        </a>
                                        }
                                        </div>
                                    }
                                </div>
                            </div>
                            {/* {childArr[i].isExpecting && childArr[i].isExpecting==1 ?
                                (<div className="week_slider pregnancy_week_slider">
                                    <ul className="days_child left">
                                        {forloopslide1}
                                    </ul>
                                    {arrowsSlide}
                                </div>
                                ) : (
                                    <div className="week_slider child_days_slider">
                                        <ul className="days_child left">
                                            {forloopslide2}
                                        </ul>
                                        {arrowsSlide}
                                    </div>
                                )} */}
                                
                                
                                {childArr[i].isExpecting && childArr[i].isExpecting==1?
                                    (<div> 
                                    {childArr[i].age.day>0 ?
                                    (
                                        <span className="child_age_info M16_42 expecting_gray_block">{this.state.userName} you are {childArr[i].currentWeek} Weeks and {childArr[i].age.day}Days Pregnant</span>
                                    ):(
                                        <span className="child_age_info M16_42 expecting_gray_block">{this.state.userName} you are {childArr[i].currentWeek} Weeks Pregnant</span>)}
                                {parseInt(childArr[i].age.month) > 0 && parseInt(childArr[i].age.day) > 0 &&
                                    childArr[i].age.day == 1 ?
                                    (this.state.totalDays = (childArr[i].age.week * 7) + childArr[i].age.day + ' Day'):
                                    (this.state.totalDays = (childArr[i].age.week * 7) + childArr[i].age.day + ' Days')
                                }       
                                {window.innerWidth < 767 ?
                                (<span className="baby_dueDate_info R14_61">Baby due in {childArr[i].age.month} m {this.state.totalDays} </span>):(<span className="baby_dueDate_info M14_61">Baby due in ' {childArr[i].age.month} m {this.state.totalDays} </span>)
                                }

                                </div>):
                                (<div>
                                {childArr[i].childName &&
                                <div className="none">
                                {this.state.childName = childArr[i].childName}
                                </div>
                                }
                                {childArr[i].age.day == 1 ?
                                (<div className="none">
                                    {this.state.totalDays = (childArr[i].age.week * 7) + childArr[i].age.day + ' Day'}</div>):(
                                <div className="none">
                                {this.state.totalDays = (childArr[i].age.week * 7) + childArr[i].age.day + ' Days'}</div>)}    

                                {childArr[i].age.year ?
                                (<div>
                                {childArr[i].age.year >= 1 && this.state.childName!='' && this.state.childName.charAt(0) ?
                                    (<span className="child_age_info M16_42">{this.state.childName.charAt(0).toUpperCase() + this.state.childName.substr(1).toLowerCase() + ' is ' + childArr[i].age.year + ' Yrs ' + childArr[i].age.month + ' Mon ' + this.state.totalDays} Old</span>)
                                    :(<span className="child_age_info M16_42">{this.state.childName.charAt(0).toUpperCase() + this.state.childName.substr(1).toLowerCase() + ' is ' + childArr[i].age.year + ' Yrs ' + childArr[i].age.month + ' Mon ' + this.state.totalDays}Old</span>)}
                                    </div>):
                                    (<span className="child_age_info M16_42" id="chld_info">{this.state.childName.charAt(0).toUpperCase() + this.state.childName.substr(1).toLowerCase() + ' is ' + childArr[i].age.month + ' Mon ' + this.state.totalDays} Old</span>
                                )}
                                </div>)}
                        </div>


                    );
                    this.setState({ sliderData: sliderData1 });
                }
            }
            if(window.innerWidth < 767){
                if(this.state.mealRecpData.eachMealHighestRatingImg && this.state.mealRecpData.eachMealHighestRatingImg['early Morning']){
                    document.querySelector('.meal-slider-cnt ul').style.width="824px";
                }else{
                    document.querySelector('.meal-slider-cnt ul').style.width="690px";
                }
            }else{
                if(this.state.mealRecpData.eachMealHighestRatingImg && this.state.mealRecpData.eachMealHighestRatingImg['early Morning']){
                    document.querySelector('.meal-slider-cnt ul').style.width="1480px";
                }else{
                    document.querySelector('.meal-slider-cnt ul').style.width="1234px";
                }
            }

        }
    }
    // sliderCall(){
    //     var liWidth ='';
    //         var expSlider5 ='';
    //         if(document.querySelector(".week_slider li")){
    //             liWidth = document.querySelector(".week_slider li").offsetWidth;
    //         }
            
    //         if (document.getElementsByClassName('week_slider') && document.getElementsByClassName('week_slider').length > 0 && document.getElementsByClassName('week_slider')[0].getElementsByTagName('li') && document.getElementsByClassName('week_slider')[0].getElementsByTagName('li').length > 0 && document.getElementsByClassName('week_slider')[0].getElementsByTagName('li')[0].classList.contains("active")) {
    //             var ele = document.getElementsByClassName('week_slider')[0].getElementsByTagName('li')[1];
    //         liWidth = (ele).offsetWidth;
    //     }
    //     if(document.querySelector(".week_slider li") && document.querySelector(".week_slider li.active")!=null){
    //         expSlider5 = ((liWidth + 20) * (document.querySelectorAll(".week_slider li").length - 1)) + (document.querySelector(".week_slider li.active").offsetWidth) + 30;
    //     }
    //     if (window.innerWidth < 767) {
    //         expSlider5 = expSlider5 - 10;
    //     }
    //     if(expSlider5 && document.querySelector(".week_slider ul")!=null){
    //         document.querySelector(".week_slider ul").style.width=(expSlider5)+"px";
    //         // document.querySelector(".week_slider").scrollCenter(".weekNo.active", 300);
    //         this.scrollCenter(".weekNo.active", 300);
    //         document.querySelector(".horizontal_line").style.width=(expSlider5)+"px";
    //     }
            
    // }
    // scrollCenter(elem, speed) {
    //     if (window.innerWidth < 767) {
    //         var pos = (document.querySelector('.weekNo.active') && document.querySelector('.weekNo.active').offsetLeft)?document.querySelector('.weekNo.active').offsetLeft:0;
    //         pos = pos - 156;
    //     } else {
    //         var pos = (document.querySelector('.weekNo.active') && document.querySelector('.weekNo.active').offsetLeft)?document.querySelector('.weekNo.active').offsetLeft:0;
    //         pos = pos - 156;
    //     }
    //     document.querySelector('.week_slider').scrollLeft=pos;
    //     if (window.innerWidth > 767) {
    //         actions.removeSelfClass('M14_white','R11_white');
    //         if(document.querySelector('.weekNo.active')){
    //             document.querySelector('.weekNo.active').children[0].classList.remove('R11_white');
    //             document.querySelector('.weekNo.active').children[0].classList.add('M14_white');
    //         }
    //     } else {
    //         actions.removeSelfClass('M16_white','R12_white');
    //         if(document.querySelector('.weekNo.active')){
    //             document.querySelector('.weekNo.active').children[0].classList.remove('R12_white');
    //             document.querySelector('.weekNo.active').children[0].classList.add('M16_white');
    //         }
    //     }

    //     let WkLength=document.querySelectorAll('.weekNo');
    //     let currentWeekNo=document.querySelector('.weekNo.active');
    //     for(var w=0;w < WkLength.length;w++){
    //         WkLength[w].style.background ='#fbdodd';
    //     }
    //     if(document.querySelector('.weekNo.active')){
    //         document.querySelector('.weekNo.active').style.background="#ee6794";
    //     }
    //     if(currentWeekNo && currentWeekNo.parentNode.nextSibling !=null && currentWeekNo.parentNode.nextSibling.children[0]){
    //         currentWeekNo.parentNode.nextSibling.children[0].style.background="#fb9ebd";
    //     }
    //     if(currentWeekNo && currentWeekNo.parentNode.nextSibling && currentWeekNo.parentNode.nextSibling.children[0].parentNode.nextSibling){
    //         currentWeekNo.parentNode.nextSibling.children[0].parentNode.nextSibling.children[0].style.background="#febdd3";
    //     }
    //     if(currentWeekNo && currentWeekNo.parentNode.previousSibling){
    //         currentWeekNo.parentNode.previousSibling.children[0].style.background="#fb9ebd";
    //     }
    //     if(currentWeekNo && currentWeekNo.parentNode.previousSibling && currentWeekNo.parentNode.previousSibling.children[0].parentNode.previousSibling){
    //         currentWeekNo.parentNode.previousSibling.children[0].parentNode.previousSibling.children[0].style.background="#febdd3";
    //     }
    // }
       // weekScrollLeft() {
    //     let WkLength=document.querySelectorAll('.weekNo');
    //     var val=WkLength.length; 
    //     var id;
    //     for(var i=0; i<val; i++){
    //         if(WkLength[i].classList.contains("active")){
    //             id=i;
    //             break;
    //         }
    //     }
    //     console.log("calScrolleft===========>", val);
    //     let id1 = parseInt(id) + 1;
    //     let monthSliderWidth = document.querySelector('.week_slider').offsetWidth;
    //     let tablinkBorderWidth = 1;
    //     let tablinkMarRight = 14;
    //     if (window.innerWidth < 767) {
    //         tablinkMarRight = 9;
    //         tablinkBorderWidth = 2
    //     }
    //     let tablinkWidth = (document.querySelector('.weekNo') ? document.querySelector('.weekNo').offsetWidth : 0) + (2 * tablinkBorderWidth);
    //     let tablinkTotalWidth = tablinkWidth + tablinkMarRight;
    
    //     let noOfTablink = (monthSliderWidth / tablinkTotalWidth) / 2;
    
    //     let activelinkLeft = (tablinkWidth * (noOfTablink - Math.floor(noOfTablink))) + (tablinkTotalWidth * (Math.floor(noOfTablink) - 1)) + (tablinkWidth / 2);
    
    //     if ((id1 + Math.floor(noOfTablink)) > val) {
    //         return document.querySelector('.week_slider').scrollLeft=(document.querySelector('.week_slider').firstElementChild.offsetWidth);
    //     } else {
    //         return document.querySelector('.week_slider').scrollLeft=((tablinkTotalWidth * (id1 - 1)) - activelinkLeft)+35;
    //     }
    // }
    // slideDays(e) {
    //     let scrollVal = 0;
    //     if (e.target.classList.contains("next") || e.target.classList.contains("dev_next")) {
    //         scrollVal = document.querySelector(".week_slider").scrollLeft + 100;
    //         document.querySelector(".week_slider").scrollLeft=scrollVal;
    //     } else {
    //         scrollVal = document.querySelector(".week_slider").scrollLeft - 100;
    //         document.querySelector(".week_slider").scrollLeft=scrollVal;
    //     }
    //     // if (window.innerWidth > 767) {
    //     //     document.querySelector('.arw_disable').classList.remove('arw_disable');
    //     //     if (scrollVal < 1) {
    //     //         e.target.parentNode.className.contains('prev').addClass('arw_disable');
    //     //     }
    //     //     if (scrollVal >= $(".week_slider").find('ul').width() - $(".week_slider").width()) {
    //     //         $(e).parent().find('.next').addClass('arw_disable');
    //     //     }
    //     // }
    // }
    // activeWeek(e, day) {
    //     if(e.target.attributes.rel==undefined){
    //         var cls= e.target.parentNode;
    //     }else{
    //         var cls= e.target;
    //     }
    //     var day1=parseInt(cls.attributes.rel.value);
    //     var weeks= document.querySelectorAll(".weekNo");
    //     for(var i=0;i<weeks.length;i++){
    //         if(weeks[i].classList.contains("active")){
    //             weeks[i].classList.remove("active");
    //         }
    //     }
    //     if (!cls.classList.contains("active")) {
    //         cls.classList.add("active");
    //     }
    //     this.scrollCenter(".weekNo.active", 300);
    //     this.clickWeek(day1);
    // }
    clickWeek(weekNo){
        service.showLoader();
        if(weekNo==0){
            weekNo=1;
        }
        if(weekNo == 8){
            weekNo=9;
        }
        let selArticle = this.state.articleData[weekNo-1];
        this.setState({selArticle:selArticle},()=>{
            setTimeout(()=>{
            service.hideLoader();
            },200);
        });
    }
    diffBetDatesInDays(date1) {
        // debugger;
        var dt = new Date();
        var dt2 = date1.toString();
        if(dt2!=''){
            dt2 = dt2.replace(/-/g, '/');
        }
        var Difference_In_Time = dt.getTime() - new Date(dt2).getTime();
        //return parseInt(Difference_In_Time / (1000 * 3600 * 24));
        return parseInt(Difference_In_Time / (1000 * 60 * 60 * 24));
    }
    showChildFeed(id, chId, chDob, chName, chGender, userExpecting, e, NumOfdays, callfunctionFrom = 2){
        this.setState({selected_child_id:chId});
        var childArr=this.state.feedProfile;
        var age = '';
            for(var k=0;k<childArr.length;k++){
                if(childArr[k]['childId']==chId){
                    if(childArr[k].isExpecting!=1){
                        if((childArr[k].age.year == 0 && (childArr[k].age.month > 8 || childArr[k].age.month == 8)) || ((childArr[k].age.year != 0 && childArr[k].age.year < 2) || (childArr[k].age.year == 2 && childArr[k].age.month < 1))  ){
                            service.showLoader();
                            this.feedProfile("selectChild",chId,1);
                            age = "0 to 2 yrs";
                        }
                        else{
                            if(childArr[k].age.year > 2 && childArr[k].age.year < 4){
                                age = "2 to 4 yrs";
                            }else if(childArr[k].age.year > 4){
                                age = "4+ yrs";
                            }
                            document.getElementsByClassName('childProfile_overlay2')[0].style.display = 'block';
                            document.querySelector('body').style.overflow = "hidden";
                        }
                    }else if(childArr[k].isExpecting==1){
                        if(this.state.isApp){
                            age = "expecting";
                            this.pregAppCall();
                        }else{
                            window.location.href=service.getRedirectUrl("/tools/pregnancy-diet-plan/");
                        }
                    }
                    if(this.state.isApp){
                        var profileName = "";
                        if(age=="2 to 4 yrs"){
                            profileName = "Toddler 2 to 4 yrs";
                        }else if(age=="4+ yrs"){
                            profileName = "Kid 4+ yrs";
                        }else if(age=="expecting"){
                            profileName = "Expecting";
                        }else if(age = "0 to 2 yrs"){
                            profileName = "0 to 2 yrs";
                        }else{
                            profileName = "Trying to Conceive";
                        }
                        var loginStatus= (global.ftk && global.ftk != "") ? 'Logged in' : 'Non-Logged in';
                        var eventName ='Meal Planner| ' + loginStatus + '|Homepage Actions';
                        var actionName = profileName+'|'+age;
                        var obj={};
                        obj.gaObj = eventName + '_' +actionName ;
                            // "eventdata": {
                            // "event_action": actionName,
                            // "event_label": ""
                            // }
                        // }
                        trackEvent(obj);
                    }
                }
                
            }
            document.querySelector('.child-prof-overlay').style.display="none";
            document.querySelector('body').style.overflow = "visible";
    }
    selMealRecp(check,id,flag){
        var recipeType;
        let selData = [];
        let mealList =  document.querySelectorAll(".mealList");
        for(var i=0; i < mealList.length; i++)
            {
                if(mealList[i].classList.contains('selected-meal')){
                    mealList[i].classList.remove('selected-meal');
                    mealList[i].classList.add('meal-slide');
                }
            }
            if(check==undefined || check=="undefined"){
                check="Dinner";
            }
            if(check == "Mid Morning Snack"){
                check = "Mid";
            }else if(check == "Evening Snack"){
                check = "Evening";
            }else if(check == "early Morning"){
                check = "early";
            }
            if(document.querySelector("."+check)!=null){
                document.querySelector("."+check).classList.add('selected-meal');
            }
            if(check == "Mid" || check == "Mid Morning Snack")
            {
                selData=this.state.mealRecpData['childMidMorningObj'];
                id=3;
                recipeType="Mid-Morning";
            }else if(check == "Lunch"){
                selData=this.state.mealRecpData['childLunchObj'];
                id=4;
                recipeType=check;
            }else if(check == "Dinner"){
                selData=this.state.mealRecpData['childDinnerObj'];
                id=6;
                recipeType=check;
            }else if(check == "Evening"){
                selData=this.state.mealRecpData['childEveningObj'];
                id=5;
                recipeType=check;
            }else if(check == "EarlyMorning" || check == "early" || check == "Early Morning"){
                selData=this.state.mealRecpData['childEarlyMorningObj'];
                id=1;
                recipeType="Early Morning";
            }else if(check == "Breakfast"){
                selData=this.state.mealRecpData['childBreakfastObj'];
                id=2;
                recipeType=check;
            }
            if(global.ftk && this.state.feedProfile[0]){
                this.objtoArray(selData);
            }else{
                this.setState({mealSelRecp:selData});
            }
            this.setState({recipes:recipeType});
            Cookies.set("recipeType",recipeType);
            var mealCardPosition=this.calScrollLeft(id);
            document.querySelector('.meal-slider-cnt').scrollLeft=mealCardPosition;
            if(this.state.isApp && flag!="onLoad"){

                let isToggleSet;
                if(document.querySelector(".online-toggle").classList.contains("show-non-veg")){
                    isToggleSet="Off";
                }else{
                    isToggleSet="On";
                }
                let appGTMJson = {
                    "appurl": [
                        {
                          "pagetype": "appGaEvent",
                          "EventType": "appGaEvent",
                          "gaEvent": "",
                          "gajsonEvent": {
                            "meal_category": check === "Mid" ? "Mid Morning Snack" : check,
                            "veg_toggle": isToggleSet,
                            "recipe_id":"",
                            "recipe_name":"",
                            "season":"",
                            "day":"",
                            "shared_platform":"",
                            "article_id":"",
                            "article_name":"",
                            "action_type": "meal category tile click",
                            "page_type":"baby meal palnner"
                          },
                          "webengageEvent": {
                            "eventname": "bmp_homepage_actions",
                            "eventdata": {
                                "meal_category": check === "Mid" ? "Mid Morning Snack" : check,
                                "veg_toggle": isToggleSet,
                                "recipe_id":"",
                                "recipe_name":"",
                                "season":"",
                                "day":"",
                                "shared_platform":"",
                                "article_id":"",
                                "article_name":"",
                                "action_type": "meal category tile click",
                                "page_type":"baby meal palnner",
                                "sendWithoutGtm": "yes"          //mixpanel event send without GTM
                            }
                          },
                          "jarvisEvent": {
                            "eventname": "bmp_homepage_actions",
                            "eventdata": {
                                "meal_category": check === "Mid" ? "Mid Morning Snack" : check,
                                "veg_toggle": isToggleSet,
                                "recipe_id":"",
                                "recipe_name":"",
                                "season":"",
                                "day":"",
                                "shared_platform":"",
                                "article_id":"",
                                "article_name":"",
                                "action_type": "meal category tile click",
                                "page_type":"baby meal palnner"
                            }
                          }
                        }
                      ]
                    }; 
                    service.jsontracker(JSON.stringify(appGTMJson));

                var loginStatus= (global.ftk && global.ftk != "") ? 'Logged in' : 'Non-Logged in';
                var eventName ='Meal Planner| ' + loginStatus + '|Homepage Actions';
                var obj={};
                obj.gaObj = eventName + "_Today's Meal" + '_'+ recipeType;
                    // "eventdata": {
                    //   "event_action": "Today's Meal",
                    //   "event_label": recipeType
                    // }
                //   }
                  actions.trackEvent(obj);
            }
    }
    childDetails(name){
        if(this.state.isApp){
            var loginStatus= (global.ftk && global.ftk != "") ? 'Logged in' : 'Non-Logged in';
            var eventName ='Meal Planner| ' + loginStatus + '|Homepage Actions';
            var obj={};
            obj.gaObj = eventName +'_Baby 0 to 2 Yrs|0 to 2 Yrs';
                // "eventdata": {
                //   "event_action": "Baby 0 to 2 Yrs|0 to 2 Yrs",
                //   "event_label": ""
                // }
            //   }
              actions.trackEvent(obj);
        }
        document.getElementsByClassName('childProfile_overlay1')[0].style.display = 'block';
        document.querySelector('body').style.overflow="hidden";
    }
    closechildPopup(cls){
        document.getElementsByClassName(cls)[0].style.display = 'none';
        document.querySelector('body').style.overflow = "visible";
        if(this.state.isApp){
            let appGTMJson = {
                "appurl": [
                    {
                      "pagetype": "appGaEvent",
                      "EventType": "appGaEvent",
                      "gaEvent": "",
                      "gajsonEvent": {
                        "profile": "Baby 0 to 2 yrs",
                        "action_type": "cancelled"
                      },
                      "webengageEvent": {
                        "eventname": "bmp_hmpg_profile_actions",
                        "eventdata": {
                            "profile": "Baby 0 to 2 yrs",
                            "action_type": "cancelled",
                            "sendWithoutGtm": "yes"          //mixpanel event send without GTM
                        }
                      },
                      "jarvisEvent": {
                        "eventname": "bmp_hmpg_profile_actions",
                        "eventdata": {
                            "profile": "Baby 0 to 2 yrs",
                            "action_type": "cancelled"
                        }
                      }
                    }
                  ]
                }; 
                service.jsontracker(JSON.stringify(appGTMJson));

        }
    }
    childAgeDetails(age){
        if(this.state.isApp){
            var profileName = "";
            if(age=="2 to 4 yrs"){
                profileName = "Toddler 2 to 4 yrs";
            }else if(age=="4+ yrs"){
                profileName = "Kid 4+ yrs";
            }else if(age=="expecting"){
                profileName = "Expecting";
            }else{
                profileName = "Trying to Conceive";
            }
            var loginStatus= (global.ftk && global.ftk != "") ? 'Logged in' : 'Non-Logged in';
            var eventName ='Meal Planner| ' + loginStatus + '|Homepage Actions';
            var actionName = profileName+'|'+age;
            var obj={};
            obj.gaObj = eventName +'_'+ actionName;
                // "eventdata": {
                // "event_action": actionName,
                // "event_label": ""
                // }
            // }
            trackEvent(obj);
        }
        if(age=="expecting"){
            // if(this.state.isApp){
            //     window.location.href = service.getRedirectUrl("https://parenting.firstcry.com/tools/deit-plan-mom/?from=app");
            // }else{
            //     window.location.href = service.getRedirectUrl("https://parenting.firstcry.com/tools/deit-plan-mom");
            // }
        }else{
            document.getElementsByClassName('childProfile_overlay2')[0].style.display = 'block';
            document.querySelector('body').style.overflow = "hidden";
        }
    }
    componentWillUnmount() {
        document.removeEventListener("click", this.domClick);  
    }
    objtoArray(mealSelRecp){
        var arr=[];
        if(mealSelRecp.length == 1){
            mealSelRecp = mealSelRecp[0];
            var fooArray =  Object.entries(mealSelRecp);
                    fooArray.forEach(([key, value]) => {
                        arr.push(value);
                    });
        //   console.log("this.state.mealSelRecp================>",arr);
          this.setState({mealSelRecp:arr});
        }else{
            this.setState({mealSelRecp:mealSelRecp});
        }
    }
    shareOn(id, recipeImg, recipeName, desc, articleUrl) {
        // console.log("share============>",id.target.nextSibling);
        if(this.state.isApp){
            if(recipeName){
                var shareText=recipeName;
            }else{
                // sample text for share
                var shareText="";
            }
            if(recipeImg){
                var thmbnailurl=recipeImg;
            }else{
                var thmbnailurl="";
            }
            var articleurl = articleUrl + "?from=app";
            var shareTXT = "Here is an interesting Firstcry Parenting article shared with you! ";
            var deepjson = {
                "appurl": [{
                    "pagetype": "share",
                    "shareText": shareTXT,
                    "thumbnailUrl": thmbnailurl,
                    "shareUrl": articleurl,
                    "desc": desc && desc.slice(0,300),
                    "title":shareText
                }]
            };
            service.jsontracker(JSON.stringify(deepjson));
            var loginStatus= (global.ftk && global.ftk != "") ? 'Logged in' : 'Non-Logged in';
            var eventName ='Meal Planner| ' + loginStatus + '|Homepage Actions';
            var obj={};
            obj.gaObj = eventName + '_Article Share';
                // "eventdata": {
                //     "event_action": "Article Share",
                //     "event_label": ""
                // }
            // }
            actions.trackEvent(obj);
        }else{
            let ary=document.querySelectorAll(".sharing-options");
            for(var i=0;i<ary.length;i++){
                ary[i].style.display = 'none';
            }
            if (window.innerWidth < 767) {
                id.target.nextSibling.style.display = 'block';
                document.getElementsByClassName('share-overlay')[0].style.display = 'block';
            }
            id.target.nextSibling.style.display = 'block';
        }
    }
    viewArticle(stageId, articleId, articleUrl, viewc, likec, artNm, e) {
        // let postData = {
        //     "articleId": articleId,
        //     "actionStatus": "1",
        //     "stageId": stageId,
        // }
        let postData = {
            "articleId": articleId,
            "post_status":"publish"
        }
        // var url = global.api_ci_url + "DietplanBaby/getViewAction";
        // var url = global.api_url + "dietplan/savearticleviewaction";
        // var url = "https://community.fcappservices.in/blogs/setarticleviewcount";
        var url = global.api_ci_url + "MealPlanner/setArtUserView";
        
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                 if(this.state.isApp){
                    var deepjson = { 
                        "appurl": [{ 
                            "pagetype": "communitywebview",
                            "communityWebViewUrl":articleUrl+"?from=app",
                            "communityWebViewTitle":artNm,
                            "feed":"true" 
                        }] 
                    };
                    service.jsontracker(JSON.stringify(deepjson));
                }else{
                    window.location.href = service.getRedirectUrl(articleUrl);
                }
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    likeArticle(artiID, stageId, e, likecount, viewcnt, arttitle,flag) {
        // console.log("json===============>");
        let cls = e.target;
        if (global.ftk !== '') {
            service.showLoader();
            if(flag=="article"){
                var postData = {
                    "stageId": stageId,
                    "articleId": artiID,
                    "actionStatus": "1"
                }
                // var url = global.api_ci_url + "DietplanBaby/getLikeAction";
                var url = global.api_url + "dietplan/savearticlelikeaction";
            }else{
                var postData = {
                    "recipeid":stageId,
                    "status":1
                }
                // var url = global.api_ci_url + "DietplanBaby/getLikeAction";
                var url = global.api_url + "dietplan/setrecipeuserlike";
                
            }
            service.postServiceCall(url, postData).then((json) => {
                if (json['result'] == "success") {
                    cls.classList.add('active');
                    cls.nextSibling.firstElementChild.innerHTML = (++likecount);
                }
                service.hideLoader();
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
            return true;
        } else {
            if (this.state.isApp) {
                actions.loginCallBack1();
            } else {
                service.showAlert("Please Login");
                window.location.href = service.getRedirectUrl(global.loginUrl + '?URL=' + global.currentURL);
                return false;
            }
        }
    }
    changeData(id, type, status) {
        let mealSelRecp = this.state.mealSelRecp;
        // console.log(mealSelRecp)
        mealSelRecp && mealSelRecp.forEach((recipe) => {
            if (recipe.recipeId == id || recipe.mealId == id) {
                if (type == "bookmark") {
                    if (parseInt(status) == 1) {
                        recipe.isBookmarked = 1;
                    } else if (parseInt(status) == 0) {
                        recipe.isBookmarked = 0;
                    }
                }else if(type=="Like"){
                    if (parseInt(status) == 1) {
                        recipe.isLike = 1;
                        recipe.likeCount = parseInt(recipe.likeCount) + 1;
                    } 
                }
            }
        });
        this.setState({ mealSelRecp: mealSelRecp });
    }
    // setBookMark(articleId, status,flag) {
    //     if (global.ftk != '') {
    //         service.showLoader();
    //         if(flag=="article"){
    //             var postData = {
    //                 "articleId": articleId,
    //                 "status": status.toString()
    //             }
    //             var url = global.api_ci_url + "DietplanBaby/setBookMark";
    //         }else{
    //             var postData = {
    //                 "articleId": articleId,
    //                 "status": status.toString()
    //             }
    //             var url = global.api_ci_url + "dietplan/setrecipebookmark";
                
    //         }
            
    //         service.postServiceCall(url, postData).then((json) => {
    //             if (json['msg'] == "1") {
    //                 this.changeData(articleId, "bookmark", status);
    //             }
    //             service.hideLoader();
    //         }).catch((error) => {
    //             console.error(error);
    //             service.hideLoader();
    //         });
    //         return true;
    //     } else {
    //         service.showAlert("Please Login");
    //         window.location.href = global.loginUrl + '?URL=' + global.currentURL;
    //         return false;
    //     }
    // }

    toggleSet(vegNon){
        var isToggleSet;
        if(document.querySelector(".online-toggle").classList.contains("show-non-veg")){
            isToggleSet=1;
        }else{
            isToggleSet=0;
        }
        if(this.state.isApp){

            var loginStatus= (global.ftk && global.ftk != "") ? 'Logged in' : 'Non-Logged in';
            var eventName ='Meal Planner| ' + loginStatus + '|Homepage Actions';
            var eventAction = (isToggleSet==1) ? 'Veg Recipe Toggle' :'Non-Veg Recipe Toggle';
            var obj={};
            obj.gaObj = eventName +'_'+eventAction;
                // "eventdata": {
                //   "event_action": eventAction,
                //   "event_label": ""
                // }
            //   }
            actions.trackEvent(obj);
        }
        service.showLoader();
        this.feedProfile("toggleSet",this.state.selected_child_id,isToggleSet);

        if(this.state.isApp){
            var toggleName;
            if(isToggleSet == 1){
                toggleName = "On"
            } else {
                toggleName = "Off"
            }

           let appGTMJson = {
                    "appurl": [
                        {
                          "pagetype": "appGaEvent",
                          "EventType": "appGaEvent",
                          "gaEvent": "",
                          "gajsonEvent": {
                            "meal_category": document.querySelector(".selected-meal .meal-type").innerText,
                            "veg_toggle": toggleName,
                            "recipe_id":"",
                            "recipe_name":"",
                            "season":"",
                            "day":"",
                            "shared_platform":"",
                            "article_id":"",
                            "article_name":"",
                            "action_type": "veg toggle click ",
                            "page_type":"baby meal palnner"
                          },
                          "webengageEvent": {
                            "eventname": "bmp_homepage_actions",
                            "eventdata": {
                                "meal_category": document.querySelector(".selected-meal .meal-type").innerText,
                                "veg_toggle": toggleName,
                                "recipe_id":"",
                                "recipe_name":"",
                                "season":"",
                                "day":"",
                                "shared_platform":"",
                                "article_id":"",
                                "article_name":"",
                                "action_type": "veg toggle click ",
                                "page_type":"baby meal palnner",
                                "sendWithoutGtm": "yes"          //mixpanel event send without GTM
                            }
                          },
                          "jarvisEvent": {
                            "eventname": "bmp_homepage_actions",
                            "eventdata": {
                                "meal_category": document.querySelector(".selected-meal .meal-type").innerText,
                                "veg_toggle": toggleName,
                                "recipe_id":"",
                                "recipe_name":"",
                                "season":"",
                                "day":"",
                                "shared_platform":"",
                                "article_id":"",
                                "article_name":"",
                                "action_type": "veg toggle click ",
                                "page_type":"baby meal palnner"
                            }
                          }
                        }
                      ]
                    }; 
                    service.jsontracker(JSON.stringify(appGTMJson));
            }

    }
    onKeyDownDate = (event) => {
        event.preventDefault(); // Prevents the default action for keydown
    }

    onFocusDate = (event) => {
        // console.log("onFocusDate================>", event);
        let val;
        if (event.target.value && event.target.value != '') {
            // Convert the current value to a Date object
            val = new Date(event.target.value);
            let y = val.getFullYear();
            let m = val.getMonth() + 1;
            let d = val.getDate();
            m = m > 9 ? m : "0" + m;
            d = d > 9 ? d : "0" + d;
            // Format the value to YYYY-MM-DD
            let finalVal = `${y}-${m}-${d}`;
            event.target.value = finalVal;
        }
        // Switch the input type to date
        event.target.type = "date";
        event.target.readOnly = false;
    }

    onBlurDate = (event) => {
        if (event.target.value) {
            // Convert the input value to a Date object
            const date = new Date(event.target.value);
            const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            const day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
            const month = months[date.getMonth()];
            const year = date.getFullYear();
            // Format the date to DD-MMM-YYYY
            const formattedDate = `${day}-${month}-${year}`;
            // Switch the input type back to text and set the formatted value
            // event.target.type = "text";
            // event.target.value = formattedDate;
            event.target.setAttribute('data-birth', formattedDate);
            event.target.style.color = 'black';
        }
        // Set the input to readOnly again
        // event.target.readOnly = true;
    }

    
    submit_babydate_btn() {
        if (document.querySelector("#select_child_upto2").value == "") {
            document.querySelector(".alertmsg").innerHTML="Please enter Date";
            document.querySelector('.alertMsg-overlay').style.display="block";
            setTimeout(()=>{
                document.querySelector('.alertMsg-overlay').style.display="none";
            },1000);
        } else if (document.querySelector("#baby_child_name").value.trim() == "") {
            document.querySelector(".alertmsg").innerHTML="Please enter Name";
            document.querySelector('.alertMsg-overlay').style.display="block";
            setTimeout(()=>{
                document.querySelector('.alertMsg-overlay').style.display="none";
            },1000);
            document.querySelector("#baby_child_name").value='';
        } else if (!document.querySelector(".radio_checked")) {
                    document.querySelector(".alertmsg").innerHTML="select Gender";
                    document.querySelector('.alertMsg-overlay').style.display="block";
                    setTimeout(()=>{
                        document.querySelector('.alertMsg-overlay').style.display="none";
                    },1000);
        } else {
            if(this.state.isApp){
                var childPhoto=document.querySelector('#uploadedSrc').src;
                if(childPhoto=="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-img.png"){
                    var childPhoto='';
                }
            }else{
                if(Cookies.get('uploaded_childImg')){
                    var childPhoto=Cookies.get('uploaded_childImg');
                }else{
                    var childPhoto='';
                }
            }
            var postData = {
                UE: "",
                ChildName: document.querySelector("#baby_child_name").value.trim(),
                DOB: document.querySelector("#select_child_upto2").getAttribute('data-birth'),
                Gender: document.querySelector(".radio_checked") && (document.querySelector(".radio_checked").innerText),
                IsExpected: false,
                Relationship: '',
                childPhoto: childPhoto
            };
            localStorage.setItem('saveNewChildData', JSON.stringify(postData));
            this.loadData();
            // if (this.state.isApp) {
            //     actions.loginCallBack1();
            // } else {
            //     window.location.href= service.getRedirectUrl(global.loginUrl + "?URL=" + global.currentURL);
            // }
        }
        if(this.state.isApp){
            let appGTMJson = {
                "appurl": [
                    {
                      "pagetype": "appGaEvent",
                      "EventType": "appGaEvent",
                      "gaEvent": "",
                      "gajsonEvent": {
                        "profile": "Baby 0 to 2 yrs",
                        "action_type": "Submit"
                      },
                      "webengageEvent": {
                        "eventname": "bmp_hmpg_profile_actions",
                        "eventdata": {
                            "profile": "Baby 0 to 2 yrs",
                            "action_type": "Submit",
                            "sendWithoutGtm": "yes"          //mixpanel event send without GTM
                        }
                      },
                      "jarvisEvent": {
                        "eventname": "bmp_hmpg_profile_actions",
                        "eventdata": {
                            "profile": "Baby 0 to 2 yrs",
                            "action_type": "Submit"
                        }
                      }
                    }
                  ]
                }; 
                service.jsontracker(JSON.stringify(appGTMJson));
        }

    }
    genderSelect(key,val){
        var expertInfo = this.state.expertInfo;
        expertInfo[key] = val;
        this.setState({ expertInfo: expertInfo });
        // document.querySelector("."+cls).classList.add("active");
        // if(cls=="girl"){
        //     if(document.querySelector(".boy").classList.contains("active")){
        //         document.querySelector(".boy").classList.remove("active");
        //     }
        //     document.querySelector("."+cls).setAttribute("data-icon-font",'#');
        //     document.querySelector(".boy").setAttribute("data-icon-font",'"');
        // }else{
        //     if(document.querySelector(".girl").classList.contains("active")){
        //         document.querySelector(".girl").classList.remove("active");
        //     }
        //     document.querySelector(".girl").setAttribute("data-icon-font",'"');
        //     document.querySelector("."+cls).setAttribute("data-icon-font",'#');
        // }
        // document.querySelector("."+cls).setAttribute("data-icon-font",'#');
    }
    onChange(e) {
        if (navigator.onLine) {
            var fileObj = document.getElementById("upload_child").files[0];
            if (fileObj.type.includes('image')) {
                if (fileObj) {
                    this.setState({ isMemorySelected: true });
                    // document.getElementsByClassName('file_upload_err')[0].style.display = "none";
                    // document.getElementsByClassName('file_upload_err')[0].innerHTML = "";
                    if (this.isJcropFilesLoaded) {
                        actions.afterJcropFilesLoaded(fileObj);
                    } else {
                        var _this=this;
                        service.loadJcropFiles(_this).then(function () {
                            _this.isJcropFilesLoaded = true;
                            actions.afterJcropFilesLoaded(fileObj);
                        }).catch(function () {
                            _this.setState({ isMemorySelected: false });
                            document.getElementById("upload_child").value = null;
                            return false;
                        })
                    }
                } else {
                    document.getElementById("upload_child").value = null;
                    // document.getElementsByClassName('file_upload_err')[0].style.display = "block";
                    // document.getElementsByClassName('file_upload_err')[0].style.visibility = "unset",
                    // document.getElementsByClassName('file_upload_err')[0].innerHTML = "Please Select Valid Photo";
                    return false;
                }
            } else {
                document.getElementById("upload_child").value = null;
                // document.getElementsByClassName('file_upload_err')[0].style.display = "block";
                // document.getElementsByClassName('file_upload_err')[0].innerHTML = "Please Select Valid Photo";
                return false;
            }
        } else {
            document.getElementById("upload_child").value = null;
            service.showAlert("Please Check Internet Connection!!!");
        }
    }
    calScrollLeft(id) {
        var val=6;
        // console.log("calScrolleft===========>", val);
        let id1 = parseInt(id);
        let monthSliderWidth = document.querySelector('.meal-slider-cnt').offsetWidth;
        let tablinkBorderWidth = 1;
        let tablinkMarRight = 14;
        if (window.innerWidth < 767) {
            tablinkMarRight = 10;
            tablinkBorderWidth = 2
        }
        let tablinkWidth = (document.querySelector('.mealList') ? document.querySelector('.mealList').offsetWidth : 0) + (2 * tablinkBorderWidth);
        let tablinkTotalWidth = tablinkWidth + tablinkMarRight;
    
        let noOfTablink = (monthSliderWidth / tablinkTotalWidth) / 2;
    
        let activelinkLeft = (tablinkWidth * (noOfTablink - Math.floor(noOfTablink))) + (tablinkTotalWidth * (Math.floor(noOfTablink) - 1)) + (tablinkWidth / 2);
    
        if ((id1 + Math.floor(noOfTablink)) > val) {
            return document.querySelector('.meal-slider-cnt').firstElementChild.offsetWidth;
        } else {
            return ((tablinkTotalWidth * (id1 - 1)) - activelinkLeft)
        }
    }
    myProfileCall(){
        // Cookies.set("isMealPageRefresh", '1', { expires: 1/24, domain: '.firstcry.com' });
        var deepjson = { 
            "appurl": [{ 
                "pagetype": "comunitymyprofile",
                "isFinishWindow":true 
            }] 
        };
        service.jsontracker(JSON.stringify(deepjson));
    }
    growthAppCall(flag){
        if(flag=="wt"){
            var tabVal= "weight_tab";
        }else{
            var tabVal= "height_tab";
        }
        var childID = this.state.mealRecpData && this.state.mealRecpData.childid;
        var deepjson = { 
            "appurl":[{
                "pagetype":"communitychart",
                "stageid":"0",
                "growthTrackerTab":tabVal,
                "requestURL":"https://parenting.firstcry.com/tools/child-vaccination-growth-tracker/childgraph/"+ childID + "/?from=app",
                "child_id":childID && childID.toString()
            }]
        };
        service.jsontracker(JSON.stringify(deepjson));
    }
    pregAppCall(){
        var deepjson = { 
            "appurl": [{ 
                "pagetype": "communitydietplanpregnants",
                "requestURL":"https://parenting.firstcry.com/tools/pregnancy-diet-plan/?from=app" 
            }] 
        };
        service.jsontracker(JSON.stringify(deepjson));
    }
    PleaseLogin(){
        if (global.ftk == '' || !global.ftk){
            if(this.state.isApp){
                actions.loginCallBack1();
            }else{
                window.location.href= service.getRedirectUrl(global.loginUrl + "?URL=" + global.currentURL);
            }
        }
    }
    checkTnc() {
        this.setState({ tncAgree: !this.state.tncAgree });
    }
    render() {
        let articles = this.state.selArticle;
        return (
            <main className="main-container meal-planner">
                <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                />
                {!this.state.isApp && 
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={service.getRedirectUrl("/tools/")} className="R11_9e">Tools</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Baby Meal Planner</span>
                    </div>
                    <h1 className="B24_00" id="skipToH1" tabIndex={0}>Baby Meal Planner (8 to 24 Months)</h1>
                </div>
                }
                {this.state.isApp &&
                    <div className="app-header">
                            <span data-icon-font="s" className="icon" onClick={() => onBackPressed()}></span>
                        <span className="M16_pink">Meal Planner</span>
                    </div>
                }
                <div className="sub-container left" style={this.state.isApp ? { marginTop: '50px' } : {}}>
                    <div className="data-container left">
                        {/* {this.state.mealRecpData && this.state.mealRecpData.bannerRecImage>0 &&  */}
                        <div className="meal-planner-banner recipebanner">
                            { global.ftk ?
                            <div className="bannerimg loginbanner">
                                <div className="banner-black"></div>
                                {this.state.mealRecpData && this.state.mealRecpData.bannerRecImage && this.state.mealRecpData.bannerRecImage!=undefined &&
                                <img src={ this.state.mealRecpData.bannerRecImage.replace("http://", "https://")} onError={(e) => (e.target.src = this.state.mealRecpData && this.state.mealRecpData.bannerRecImage!=undefined && this.state.mealRecpData.bannerRecImage.replace("http://", "https://"))} alt="Baby Meal Planner" title="Baby Meal Planner" name="Baby Meal Planner"/>
                                }
                            </div>
                            :
                            <div className="bannerimg nonloginbanner">
                                <div className="banner-black"></div>
                                <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/01-welcome-text-bg.jpg" alt="Baby Meal Planner" title="Baby Meal Planner" name="Baby Meal Planner" />
                            </div>
                            }
                            { global.ftk ?
                            <div className="welcome-cnt welbottom">
                                <div className="welcometxt1 nonlog-name R30_FF" >Welcome {this.state.userName}</div>
                                {this.state.welComeMsg &&
                                <div className="welcometxt2 nonlog-desc R13_FF">{this.state.welComeMsg.replace(/&nbsp;/g, ' ')}</div>
                                }
                            </div>
                            :
                            <div className="welcome-cnt">
                                <div className="welcometxt1 log-name R30_FF">Welcome</div>
                                <div className="welcometxt2 log-desc R13_FF"><span>{this.state.nonlogintext}</span></div>
                                <div className="loginButton" onClick={() =>{ this.PleaseLogin()}}>
                                    <span>Login Now</span>
                                </div>
                            </div>
                            }
                        </div>
                        {/* } */}
                    { global.ftk  && this.state.windowWidth < 768 &&
                    <div className="mobile_view">
                        {this.state.mealRecpData && this.state.mealRecpData.childid!='' ?
                        <div className="child_pro_cont">
                            <div id="slider" className="ui-card-slider four_child_slider">
                                <div className="child_image">
                                    {global.ftk && this.state.mealRecpData && this.state.mealRecpData.childPhoto!='' ?
                                    <img src={this.state.mealRecpData.childPhoto} className="dev_swap_pic" alt="Baby Meal Planner" title="Baby Meal Planner" name="Baby Meal Planner"/>
                                    :
                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/mob_baby.png" className="dev_swap_pic" alt="Baby Meal Planner" title="Baby Meal Planner" name="Baby Meal Planner"/>
                                    }
                                    <div className="edit-child" onClick={(e) =>{ this.onEditChild(e)}}><label className="icon dev_swap_pic" data-icon-font="H"></label></div>
                                    <div className="edit-child" onClick={(e) =>{ this.onEditChild(e)}}><label className="icon dev_swap_pic" data-icon-font="H"></label></div>
                                </div>
                            </div>  
                            {this.state.sliderData}                        
                        </div>
                        :
                        <div className="nonloggedIn">
                            <div className="more-info">
                                <div className="about-yourself">
                                    <span className="about-yourself-txt M15_42">Tell us more about yourself to get more Personalized Feed</span>
                                </div>
                                <div className = "slider-cont-meal">
                                    <div className="childprofile-container left">
                                        <ul className="child-container left">
                                            <li className="child-pic active" id="child_baby" onClick={()=>this.childDetails('0 to 2 yrs')}>
                                                <div className="select-child">
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/mob_baby.png" className="dev_pic"  alt="Baby Meal Planner" title="Baby Meal Planner" name="Baby Meal Planner"/>
                                                </div>
                                                <div className="edit-child" onClick={()=>this.childDetails('0 to 2 yrs')}><label className="icon dev_swap_pic" data-icon-font="H"></label></div>
                                                <div className="tabs_cont">
                                                    <span className="R14_42 dev_pic">Baby <br/>0 to 2 yrs</span>
                                                </div>
                                            </li>
                                            <li className="child-pic" id="child_toddler" onClick={()=>this.childAgeDetails('2 to 4 yrs')}>
                                                <div className="select-child">
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/mob_toddler_profile.png" className="dev_pic"  alt="Baby Meal Planner" title="Baby Meal Planner" name="Baby Meal Planner"/>
                                                </div>
                                                <div className="tabs_cont">
                                                    <span className="R14_42 dev_pic">Toddler <br/>2 to 4 yrs</span>
                                                </div>
                                            </li>
                                            <li className="child-pic" id="child_kid" onClick={()=>this.childAgeDetails('4+ yrs')}>
                                                <div className="select-child">
                                                    <div className="inner-circle"></div>
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/mob_6yrkid_profile.png" className="dev_pic" />
                                                </div>
                                                <div className="tabs_cont">
                                                    <span className="R14_42 dev_pic">Kid <br/>4+ yrs</span>
                                                </div>
                                            </li>
                                            <li className="child-pic" id="child_expecting" onClick={()=>this.childAgeDetails('expecting')}>
                                                {this.state.isApp ?
                                                    <a onClick={()=>{this.pregAppCall()}}>
                                                        <div className="select-child">
                                                            <div className="inner-circle"></div>
                                                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/mob_expecting.png" className="dev_pic" />
                                                        </div>
                                                        <div className="tabs_cont">
                                                            <span className="R14_42 dev_pic">Expecting</span>
                                                        </div>
                                                    </a>
                                                    :
                                                    <a href="https://parenting.firstcry.com/tools/pregnancy-diet-plan/">
                                                        <div className="select-child">
                                                            <div className="inner-circle"></div>
                                                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/mob_expecting.png" className="dev_pic" />
                                                        </div>
                                                        <div className="tabs_cont">
                                                            <span className="R14_42 dev_pic">Expecting</span>
                                                        </div>
                                                    </a>
                                                }
                                            </li>
                                            <li className="child-pic" id="child_conceive" onClick={()=>this.childAgeDetails('trytoconceivedet')}>
                                                <div className="select-child">
                                                    <div className="inner-circle"></div>
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/mob_tryingtoconceive.png" />
                                                </div>
                                                <div className="tabs_cont">
                                                    <span className="R14_42 dev_pic">Trying to<br/> Conceive</span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                    }
                        <div className="landing-block">
                            <div className="todays-meal-cnt">
                            <div className="todays-meal left">{(this.state.childName)?this.state.childName:''}{(this.state.childName)?"'s ":""}Weekly Meal plan {/*this.state.currentWeek==1 || this.state.currentWeek==0 || this.state.currentWeek==8 ? 1 : parseInt(this.state.currentWeek) - 8*/}</div>
                                <div className="right veg-non-veg">
                                    <span className="veg-only R12_9e left">Veg</span>
                                    <span className="non-veg-only R12_9e left">Veg</span>
                                    <div className={this.state.mealRecpData.bannerRecCat=="Vegetarian"?"online-toggle right":"online-toggle show-non-veg right"} onClick={()=>{this.toggleSet(this.state.mealRecpData.bannerRecCat)}}></div> 
                                </div>
                            </div>
                            <div className = "slider-cont-meal">
                                <div className="meal-slider-cnt">
                                    {this.state.mealRecpData && this.state.mealRecpData!='' && 
                                    <ul>
                                         {this.state.mealRecpData.eachMealHighestRatingImg && this.state.mealRecpData.eachMealHighestRatingImg['early Morning'] &&
                                        <li className="left meal-slide mealList early" onClick={(e)=>{this.selMealRecp("early",1)}}>
                                            <div className="meal-img">
                                            <img src={this.state.mealRecpData.eachMealHighestRatingImg && this.state.mealRecpData.eachMealHighestRatingImg['early Morning'].replace("http://", "https://")} onError={(e) => (e.target.src = this.state.mealRecpData.eachMealHighestRatingImg['early Morning'].replace("http://", "https://"))} alt="Early Morning" title="Early Morning" className="GTM-category" data-title="Early Morning" />
                                                {/* <img src={this.state.mealRecpData.eachMealHighestRatingImg && this.state.mealRecpData.eachMealHighestRatingImg['early Morning']} /> */}
                                            </div>
                                            <div className="R12_61 meal-type" data-title="Early Morning">Early Morning</div>
                                        </li>
                                        }
                                        <li className="left selected-meal mealList Breakfast" onClick={(e)=>{this.selMealRecp("Breakfast",2)}}>
                                            <div className="meal-img">
                                            {this.state.mealRecpData.eachMealHighestRatingImg && this.state.mealRecpData.eachMealHighestRatingImg.Breakfast && 
                                            <img src={this.state.mealRecpData.eachMealHighestRatingImg.Breakfast.replace("http://", "https://")} onError={(e) => (e.target.src = this.state.mealRecpData.eachMealHighestRatingImg.Breakfast.replace("http://", "https://"))} alt="Breakfast" title="Breakfast" name="Breakfast" className="GTM-category" data-title="Breakfast"/>
                                            }
                                            </div>
                                            <div className="R12_61 meal-type" data-title="Breakfast">Breakfast</div>
                                        </li>
                                        <li className="left meal-slide mealList Mid" onClick={(e)=>{this.selMealRecp("Mid",3)}}>
                                            <div className="meal-img">
                                            {this.state.mealRecpData.eachMealHighestRatingImg && this.state.mealRecpData['eachMealHighestRatingImg']['Mid-morning'] &&
                                            <img src={this.state.mealRecpData['eachMealHighestRatingImg']['Mid-morning'].replace("http://", "https://")} onError={(e) => (e.target.src = this.state.mealRecpData['eachMealHighestRatingImg']['Mid-morning'].replace("http://", "https://"))} alt="Mid Morning Snack" title="Mid Morning Snack" name="Mid Morning Snack" className="GTM-category" data-title="Mid Morning Snack"/>
                                            }
                                            </div>
                                            <div className="R12_61 meal-type midmorn" data-title="Mid Morning Snack">Mid Morning Snack</div>
                                        </li>
                                        <li className="left meal-slide mealList Lunch" onClick={(e)=>{this.selMealRecp("Lunch",4)}}>
                                            <div className="meal-img">
                                            {this.state.mealRecpData.eachMealHighestRatingImg && this.state.mealRecpData.eachMealHighestRatingImg.Lunch &&
                                            <img src={this.state.mealRecpData.eachMealHighestRatingImg.Lunch.replace("http://", "https://")} onError={(e) => (e.target.src = this.state.mealRecpData.eachMealHighestRatingImg.Lunch.replace("http://", "https://"))} alt="Lunch" title="Lunch" name="Lunch" className="GTM-category" data-title="Lunch"/>
                                            }
                                            </div>
                                            <div className="R12_61 meal-type" data-title="Lunch">Lunch</div>
                                        </li>
                                        <li className="left meal-slide mealList Evening" onClick={(e)=>{this.selMealRecp("Evening",5)}}>
                                            <div className="meal-img">
                                            {this.state.mealRecpData && this.state.mealRecpData.eachMealHighestRatingImg && this.state.mealRecpData.eachMealHighestRatingImg.Evening &&
                                            <img src={this.state.mealRecpData.eachMealHighestRatingImg.Evening.replace("http://", "https://")} onError={(e) => (e.target.src = this.state.mealRecpData.eachMealHighestRatingImg.Evening.replace("http://", "https://"))} alt="Evening" title="Evening" name="Evening" className="GTM-category" data-title="Evening"/>
                                            }
                                            </div>
                                            <div className="R12_61 meal-type" data-title="Evening">Evening</div>
                                        </li>
                                        <li className="left meal-slide mealList Dinner" onClick={(e)=>{this.selMealRecp("Dinner",6)}}>
                                            <div className="meal-img">
                                            {this.state.mealRecpData.eachMealHighestRatingImg && this.state.mealRecpData.eachMealHighestRatingImg.Dinner &&
                                            <img src={this.state.mealRecpData.eachMealHighestRatingImg.Dinner.replace("http://", "https://")} onError={(e) => (e.target.src = this.state.mealRecpData.eachMealHighestRatingImg.Dinner.replace("http://", "https://"))} alt="Dinner" title="Dinner" name="Dinner" className="GTM-category" data-title="Dinner"/>
                                            }
                                            </div>
                                            <div className="R12_61 meal-type" data-title="Dinner">Dinner</div>
                                        </li>
                                    </ul>
                                    }
                                    <div className="arrows">
                                        <span className="next" onClick={(e) => { actions.slideStage(e, this, 'meal-slider-cnt') }}>
                                            <span data-icon-font="h" className="icon dev_next"></span>
                                        </span>
                                        <span className="prev" onClick={(e) => { actions.slideStage(e, this, 'meal-slider-cnt') }}>
                                            <span data-icon-font="g" className="icon dev_prev"></span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <MealRecipe mealSelRecp={this.state.mealSelRecp} eleRef={this} flag={"MealLanding"} recipeType={this.state.recipes} isApp={this.state.isApp} currentDay={this.state.mealRecpData.currentday == 0 ? this.state.mealRecpData.currentday + 1 : this.state.mealRecpData.currentday}/>
                        </div>
                        {articles && articles['articleTitle'] != '' &&
                        <div className="articles-for-you-cont">
                            <div className="articles-heading B20_42">Articles for you</div>
                            <div className="article-cont">
                                <div className="art-head-con M15_42">
                                {this.state.babyAge ?
                                    <div className="art-head left">
                                        Articles for {this.state.babyAge} old {this.state.childgender}
                                    </div>
                                    :
                                    <div className="art-head left">
                                        Articles for you
                                    </div>

                                }
                                    <div className="art-img right">
                                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/read.png"  alt="Read Icon" title="Read Icon" name="Read Icon"/>
                                    </div>
                                </div>
                                <div className="divider-line line"></div>
                            {articles && articles['articleTitle'] != '' && (articles!='' && articles!=undefined) && 
                                <div id="screenShot_0" className='diet-plan-card act-sum' data-artid={articles['articleId']} data-artname={articles['articleTitle']} >
                                    <span className="B20_42 card_title" onClick={(e) => this.viewArticle(articles['weekNo'], articles['articleId'], articles['articleUrl'].replace('http://parenting.firstcry.com/wp-content/uploads/', 'https://cdn.firstcrycdn.com/'), articles['viewCount'], articles['likeCount'], articles['articleTitle'], e)}>
                                        {articles['articleTitle']}
                                    </span>
                                    <div className="card-img" onClick={(e) => this.viewArticle(articles['weekNo'], articles['articleId'], articles['articleUrl'].replace('http://parenting.firstcry.com/wp-content/uploads/', 'https://cdn.firstcrycdn.com/'), articles['viewCount'], articles['likeCount'], articles['articleTitle'], e)}>
                                    <img src={articles['articleImage'].replace("http://", "https://")} onError={(e) => (e.target.src = this.state.articles['articleImage'].replace("http://", "https://"))} alt={articles['articleTitle']} title={articles['articleTitle']} className="articleImage"/>
                                        {/* <img src={articles['articleImage']} alt={articles['articleTitle']} title={articles['articleTitle']} /> */}
                                    </div>
                                    <div className="card-text R14_61 more" onClick={(e) => this.viewArticle(articles['weekNo'], articles['articleId'], articles['articleUrl'].replace('http://parenting.firstcry.com/wp-content/uploads/', 'https://cdn.firstcrycdn.com/'), articles['viewCount'], articles['likeCount'], articles['articleTitle'], e)}>
                                        <span>{articles["articleText"]}</span>
                                    </div>
                                    <div className="read_more_link" onClick={(e) => this.viewArticle(articles['weekNo'], articles['articleId'], articles['articleUrl'].replace('http://parenting.firstcry.com/wp-content/uploads/', 'https://cdn.firstcrycdn.com/'), articles['viewCount'], articles['likeCount'], articles['articleTitle'], e)}>
                                        <a className="readmorelink R14_link">Read More</a>
                                    </div>
                                    <div className="divider-line"></div>
                                    <div className="meal-card-actions">
                                        <div className="card-views social-actions">
                                            <span data-icon-font="$" className="icon M14_42 view-icon">
                                            </span>
                                            <span className="like-count view_count M14_42">{articles['viewCount']} Views</span>
                                        </div>
                                        <div className="card-likes social-actions like-algn">
                                            {articles && articles['isLiked'] > 0 ?
                                                (<span>
                                                    <span data-icon-font="&#xe009;" className="icon M14_42 active like-icon"></span>
                                                    <span className="like-count M14_42">
                                                        <span className="total_likes">
                                                            {articles['likeCount']}
                                                        </span> Likes</span>
                                                </span>
                                                ) :
                                                (
                                                    <span>
                                                        <span data-icon-font="&#xe009;" className="icon M14_42 like-icon" onClick={(e) => actions.likeArticle(articles['articleId'], articles['stageId'], e, articles['likeCount'], articles['viewCount'], articles['articleTitle'],"article", "", "", this.state.isApp,"article")}>
                                                        </span>
                                                        <span className="like-count M14_42">
                                                            <span className="total_likes">
                                                                {articles['likeCount']}
                                                            </span> Likes</span>
                                                    </span>
                                                )}

                                        </div>
                                        <div className="card-share right social-actions">
                                            {/* <span data-icon-font=")" className="icon M14_42 share-icon" onClick={(e) => this.shareOn(e)}></span> */}
                                            <div className="M14_42 right share-icon" onClick={(e) => this.shareOn(e,articles['articleImage'],articles['articleTitle'], articles["articleText"], articles['articleUrl'])}>
                                                <div className="fb-icon left">
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook-icon.png" alt="Facebook" title="Facebook" />
                                                </div>
                                                <div data-icon-font="" className="whtapp-icon left"></div>
                                                <div className="left share-txt">Share</div>
                                            </div>
                                            <div className="sharing-options dev_art_shr">
                                                <ul className="left">
                                                    <li className="whatsapp-share left" onClick={(e) => actions.shareArticle('whatsapp',articles['articleUrl'])}>
                                                        <span className="M16_61 social-share" id="whatsapp">
                                                            <img src="https://parenting.firstcry.com/discussions/images/whatsapp.png" className="fetusfacebookimg whatsappimgArt" alt="Baby Meal Planner" title="Baby Meal Planner" name="Baby Meal Planner"/>
                                                        </span>
                                                    </li>
                                                    <li className="facebook-share left" onClick={(e) => actions.shareArticle('facebook',articles['articleUrl'])}>
                                                        <span className="M16_61 social-share" id="facebook">
                                                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png" className="facebookimg facebookimgArt" alt="Facebook Icon" title="Facebook Icon" name="Facebook Icon"/>
                                                        </span>
                                                    </li>
                                                    <li className="twitter-share left" onClick={(e) => actions.shareArticle('twitter',articles['articleUrl'])}>
                                                        <span className="M16_61 social-share" id="twitter">
                                                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png" className="twitterimg twitterimgArt" alt="Twitter Icon" title="Twitter Icon" />
                                                        </span>
                                                    </li>
                                                    <li className="twitter-share left" onClick={(e) => actions.shareArticle('pintrest',articles['articleUrl'])}>
                                                        <span className="M16_61 social-share" id="pintrest">
                                                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png" className="pintrestimg pintrestimgArt" alt="Pintrest Icon" title="Pintrest Icon" />
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                    </div>
                              
                                </div>
                            }
                            </div>
                        </div>}
                        {/* <MealProductData ProductData={} eleRef={this}/> */}
                        <FooterMenu eleRef={this} flag="ML" recipes={this.state.recipes} isApp={this.state.isApp}/>
                    </div>
                    
                    {/* <div className="mealPop-overlay">
                        <div className="meal_popup">
                            <div className="mp-block mp-block1">
                                <div className="mp-block-title mp-block-title1">
                                    <div className="mp-alg-title left M15_11">Allergies</div>
                                    <div className="mp-cnt R12_55 left">02</div>
                                    <div data-icon-font="n" id="mpup1" className="mp-up right" onClick={() =>{ this.openMealPopupSlider('1','up') }}></div>
                                    <div data-icon-font="f" id='mpdown1' className="mp-up mp-down right" onClick={() =>{ this.openMealPopupSlider('1','down') }}></div>
                                </div>
                                <div className = "slider-cont-meal">
                                    <div className="mp-slider" id="mp-slider1">
                                        <ul>
                                            <li className="left mp-slide">
                                                <div className="mp-img">
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Peanuts-free.jpg" />
                                                </div>
                                                <div className="M15_FF mp-slide-title">Peanuts free</div>
                                            </li>
                                            <li className="left mp-slide">
                                                <div className="mp-img">
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Seafood-free.jpg" />
                                                </div>
                                                <div className="M15_FF mp-slide-title">Seafood free</div>
                                            </li>
                                            <li className="left mp-slide">
                                                <div className="mp-img">
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Dairy-Free.jpg" />
                                                </div>
                                                <div className="M15_FF mp-slide-title">Dairy Free</div>
                                            </li>
                                            <li className="left mp-slide">
                                                <div className="mp-img">
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/MANSOON.jpg" />
                                                </div>
                                                <div className="M15_FF mp-slide-title">MANSOON</div>
                                            </li>
                                            <li className="left mp-slide">
                                                <div className="mp-img">
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Peanuts-free.jpg" />
                                                </div>
                                                <div className="M15_FF mp-slide-title">Peanuts free</div>
                                            </li>
                                            <li className="left mp-slide">
                                                <div className="mp-img">
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Seafood-free.jpg" />
                                                </div>
                                                <div className="M15_FF mp-slide-title">Seafood free</div>
                                            </li>
                                        </ul>
                                        <div className="arrows">
                                            <span className="next" onClick={(e) => { actions.slideStage(e, this, 'mp-slider') }}>
                                                <span data-icon-font="h" className="icon dev_next"></span>
                                            </span>
                                            <span className="prev" onClick={(e) => { actions.slideStage(e, this, 'mp-slider') }}>
                                                <span data-icon-font="g" className="icon dev_prev"></span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mp-block mp-block2">
                                <div className="mp-block-title mp-block-title2">
                                    <div className="mp-alg-title left M15_11">Seasons</div>
                                    <div className="mp-cnt R12_55 left">02</div>
                                    <div data-icon-font="n" id="mpup2" className="mp-up right" onClick={() =>{ this.openMealPopupSlider('2','up') }}></div>
                                    <div data-icon-font="f" id='mpdown2' className="mp-up mp-down right" onClick={() =>{ this.openMealPopupSlider('2','down') }}></div>
                                </div>
                                <div className = "slider-cont-meal">
                                    <div className="mp-slider" id="mp-slider2">
                                        <ul>
                                            <li className="left mp-slide">
                                                <div className="mp-img">
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Peanuts-free.jpg" />
                                                </div>
                                                <div className="M15_FF mp-slide-title">Peanuts free</div>
                                            </li>
                                            <li className="left mp-slide">
                                                <div className="mp-img">
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Seafood-free.jpg" />
                                                </div>
                                                <div className="M15_FF mp-slide-title">Seafood free</div>
                                            </li>
                                            <li className="left mp-slide">
                                                <div className="mp-img">
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Dairy-Free.jpg" />
                                                </div>
                                                <div className="M15_FF mp-slide-title">Dairy Free</div>
                                            </li>
                                            <li className="left mp-slide">
                                                <div className="mp-img">
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/MANSOON.jpg" />
                                                </div>
                                                <div className="M15_FF mp-slide-title">MANSOON</div>
                                            </li>
                                            <li className="left mp-slide">
                                                <div className="mp-img">
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Peanuts-free.jpg" />
                                                </div>
                                                <div className="M15_FF mp-slide-title">Peanuts free</div>
                                            </li>
                                            <li className="left mp-slide">
                                                <div className="mp-img">
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Seafood-free.jpg" />
                                                </div>
                                                <div className="M15_FF mp-slide-title">Seafood free</div>
                                            </li>
                                        </ul>
                                        <div className="arrows">
                                            <span className="next" onClick={(e) => { actions.slideStage(e, this, 'mp-slider') }}>
                                                <span data-icon-font="h" className="icon dev_next"></span>
                                            </span>
                                            <span className="prev" onClick={(e) => { actions.slideStage(e, this, 'mp-slider') }}>
                                                <span data-icon-font="g" className="icon dev_prev"></span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mp-block mp-block3">
                                <div className="mp-block-title mp-block-title3">
                                    <div className="mp-alg-title left M15_11">Region</div>
                                    <div className="mp-cnt R12_55 left">02</div>
                                    <div data-icon-font="n" id="mpup3" className="mp-up right" onClick={() =>{ this.openMealPopupSlider('3','up') }}></div>
                                    <div data-icon-font="f" id='mpdown3' className="mp-up mp-down right" onClick={() =>{ this.openMealPopupSlider('3','down') }}></div>
                                </div>
                                <div className = "slider-cont-meal">
                                    <div className="mp-slider" id="mp-slider3">
                                        <ul>
                                            <li className="left mp-slide">
                                                <div className="mp-img">
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Peanuts-free.jpg" />
                                                </div>
                                                <div className="M15_FF mp-slide-title">Peanuts free</div>
                                            </li>
                                            <li className="left mp-slide">
                                                <div className="mp-img">
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Seafood-free.jpg" />
                                                </div>
                                                <div className="M15_FF mp-slide-title">Seafood free</div>
                                            </li>
                                            <li className="left mp-slide">
                                                <div className="mp-img">
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Dairy-Free.jpg" />
                                                </div>
                                                <div className="M15_FF mp-slide-title">Dairy Free</div>
                                            </li>
                                            <li className="left mp-slide">
                                                <div className="mp-img">
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/MANSOON.jpg" />
                                                </div>
                                                <div className="M15_FF mp-slide-title">MANSOON</div>
                                            </li>
                                            <li className="left mp-slide">
                                                <div className="mp-img">
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Peanuts-free.jpg" />
                                                </div>
                                                <div className="M15_FF mp-slide-title">Peanuts free</div>
                                            </li>
                                            <li className="left mp-slide">
                                                <div className="mp-img">
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Seafood-free.jpg" />
                                                </div>
                                                <div className="M15_FF mp-slide-title">Seafood free</div>
                                            </li>
                                        </ul>
                                        <div className="arrows">
                                            <span className="next" onClick={(e) => { actions.slideStage(e, this, 'mp-slider') }}>
                                                <span data-icon-font="h" className="icon dev_next"></span>
                                            </span>
                                            <span className="prev" onClick={(e) => { actions.slideStage(e, this, 'mp-slider') }}>
                                                <span data-icon-font="g" className="icon dev_prev"></span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}

                    <div className="child-prof-overlay">
                        <div className="all-child-prof">
                            <div className="close-list">
                                <div className="sel_child M15_42">Select child</div>
                                <span className="week-next" data-icon-font="h"></span>
                                {this.state.isApp ?
                                <a onClick={()=>{this.myProfileCall()}}>
                                    <div className="my_pro">
                                        <span className="icon user_icon_pop" data-icon-font="?"></span>
                                        <span className="R10_pink">My Profile</span>
                                    </div>
                                </a>
                              :
                                <a href={this.state.isApp ? "https://parenting.firstcry.com/my-account/myprofile/?from=app" : "https://parenting.firstcry.com/my-account/myprofile"} target="_blank">
                                    <div className="my_pro">
                                        <span className="icon user_icon_pop" data-icon-font="?"></span>
                                        <span className="R10_pink">My Profile</span>
                                    </div>
                                </a>
                                }
                            </div>
                            <div className="children_list">
                                <ul className="child-prof-list">
                            {this.state.feedProfile && this.state.feedProfile.length > 0 && this.state.feedProfile.map((profile,index)=>
                                    <li key={index} onClick={(e)=>{this.showChildFeed(index ,profile.childId,profile.dob, profile.childName, profile.gender, e, '','yes')}}  id={"ChilProf_"+profile.childId} className="ChilProf">
                                        <div className="name_profile">
                                    <div className="chld_prof">
                                        {profile.isExpecting!=1 && profile.childPhoto == "" ?
                                            <div>
                                                    {profile.age.year < 2 ?
                                                        (<img className="no_babyImg dev_chld_prof" src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/mob_baby.png' title={profile.childName} />):
                                                        profile.age.year < 4 ?
                                                        (<img className="no_babyImg dev_chld_prof" src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/mob_toddler_profile.png' title={profile.childName}/>
                                                        ):
                                                        (<img className="no_babyImg dev_chld_prof" src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/mob_6yrkid_profile.png' title={profile.childName}/>)}
                                            </div>
                                        
                                         :profile.isExpecting==1 ? 
                                             (<img src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/mob_expecting.png' title="Expecting Baby" className="dev_chld_prof"/>
                                             ):
                                         profile.isExpecting==1 && profile.userPic ?  
                                            (<img src={(profile.userPic)} title="Expecting Baby" className="dev_chld_prof"/>
                                            ):
                                         (<img src={profile.childPhoto && profile.childPhoto.replace("http://","https://")}className="dev_chld_prof" title={profile.childName}/>)}
                                        
                                    </div>
                                    {profile.isExpecting!=1? 
                                        (<div className="chld_name">
                                            <span className="chld_name_span R10_75">
                                                {profile.childName}
                                            </span>
                                        </div>):
                                        (<div className="chld_name">
                                            <span className="chld_name_span R10_75">Expecting</span>
                                        </div>)}
                                </div>
                                    </li>
                                

                            )}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div id="child" className="childProfile_overlay1">
                        <div className="nonlogin-child-popup">
                            <span className="close_icon icon right R14_9e" data-icon-font="C" onClick={() =>{ this.closechildPopup("childProfile_overlay1")}}></span>
                            <div className="content">
                                <span className="content-txt M15_42">ENTER CHILD DETAILS</span>
                            </div>
                            <div className="childprofile-cont">
                              
                                <div className="upload-child">
                                    <div className="profile_img">
                                        <img id="uploadedSrc" className="uploadedSrc" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-img.png"  alt="Default Profile Icon" title="Default Profile Icon" name="Default Profile Icon"/>
                                    </div>
                                    {this.state.isApp ?
                                        <div className="edit-child" onClick={()=>{actions.appGallery("profilePic")}}>
                                            <label htmlFor="upload_child" className="icon" data-icon-font="H"></label> 
                                             {/* <input type="file" name="child_img" id="upload_child" className="upload_chldpic" accept="image/*"  onChange={(e) => this.onChange(e)} /> */}
                                            <input type="button" value="Upload Photo" className="uploadImgSubmit" rel="0" />
                                            <div className="file_upload_err_profile"></div>
                                        </div> 
                                    :
                                    <div className="edit-child">
                                        <label htmlFor="upload_child" className="icon" data-icon-font="H"></label> 
                                        <input type="file" name="child_img" id="upload_child" className="upload_chldpic" accept="image/*"  onChange={(e) => this.onChange(e)} />
                                        <input type="button" value="Upload Photo" className="uploadImgSubmit" rel="0" />
                                        <div className="file_upload_err_profile"></div>
                                    </div> 
                                    }   
                                </div>
                                <label htmlFor="upload_child" className="R14_link addProf">Add Profile Photo</label>
                            </div>
                            <input type="hidden" id="addChildPicUrl"/>
                            <div className="date-cont">
                                {/* <div className="date-tab">
                                    <input type="text" className="enter-date R14_42 dev_childDOB" id="select_child_upto2" />
                                    <label className="textfield-label">Date of birth</label>
                                    <span className="icon calendar-icon right" id="calendar-icon2" data-icon-font="w"></span>
                                </div> */}
                                <div className="date-tab">
                <input
                    type="date"
                    className="rm_inp duedate-datepicker R17_42"
                    id="select_child_upto2"
                    readOnly
                    placeholder="Date of birth"
                    onKeyDown={(e) => this.onKeyDownDate(e)}
                    onFocus={(e) => this.onFocusDate(e)}
                    onBlur={(e) => this.onBlurDate(e)}
                    style={{ fontSize: '16px' }} // Prevent zoom on iOS
                />
                <label className="textfield-label">Date of birth</label>
                <span className="icon calendar-icon right" id="calendar-icon2" data-icon-font="w"></span>
            </div>

                            </div>
                            <div className="name-cont">
                                <div className="name-tab">
                                    <input type="text" className="enter-date R14_42 dev_childName" id="baby_child_name" />
                                    <label className="textfield-label">Child Name</label>
                                </div>
                            </div>
                            {/* <div className="child_gender">
                                <div className="gender_btn mrg-rgt-15" onClick={()=>{this.genderSelect("girl")}}>
                                    <span data-icon-font="&quot;" className="icon radio_check girl" data-value="Girl"></span>
                                    <label className="rdopt R13_42">Girl</label>
                                </div>
                                <div className="gender_btn" onClick={()=>{this.genderSelect("boy")}}>
                                    <span data-icon-font="&quot;" className="icon radio_check boy" data-value="Boy"></span>
                                    <label className="rdopt R13_42">Boy</label>
                                </div>
                                <input type="hidden" className="dev_ageGrp" value="0 to 2 yrs" />
                            </div> */}
                            {/*  */}
                                <div className="child_gender">
                                    <span className={this.state.expertInfo['gender'] == 'girl' ? "gender_btn mrg-rgt-15 radio_btn radio_checked" : "gender_btn mrg-rgt-15 radio_btn"}>
                                        <label className="rdopt R13_42"><input type="radio" value="girl"
                                            checked={this.state.expertInfo['gender'] == 'girl'}
                                            onChange={() => this.genderSelect('gender','girl')} />Girl</label>
                                    </span>
                                    <span className={this.state.expertInfo['gender'] == 'boy' ? "gender_btn radio_btn radio_checked" : "gender_btn radio_btn"}>
                                        <label className="rdopt R13_42"><input type="radio" value="boy"
                                            checked={this.state.expertInfo['gender'] == 'boy'}
                                            onChange={() => this.genderSelect('gender','boy')} />Boy</label>
                                    </span>
                                <input type="hidden" className="dev_ageGrp" value="0 to 2 yrs" />
                                </div>
                            {/*  */}
                            <div className="mob_submit_actions">
                                <div className="askB_1 calculateDuedate" onClick={()=>{this.submit_babydate_btn()}}>
                                    <span className="clcdue M14_white">SUBMIT</span>
                                </div>
                                <div className="askB_1 calculateDuedate cancel_editchild" onClick={() =>{ this.closechildPopup("childProfile_overlay1")}}>
                                    <span className="clcdue M14_9e" id="child_det">CANCEL</span>
                                </div>
                            </div>
                            {/* <div className="check-msg R14_75 left">
                                
                                {this.state.tncAgree ?
                                    <span className="R10_75 icon check-icon" data-icon-font="A" onClick={() => this.checkTnc()}></span>
                                    :
                                    <span className="R10_75 icon check-icon" data-icon-font="z" onClick={() => this.checkTnc()}></span>
                                }
                                Don't prompt me again
                            </div> */}
                            <div className="right showhidesave">
                                <div className="askB_1 calculateDuedate right" onClick={()=>{this.submit_babydate_btn()}}>
                                    <span className="clcdue M14_white">SUBMIT</span>
                                </div>
                                <div className="askB_1 calculateDuedate cancel_editchild left" onClick={() =>{ this.closechildPopup("childProfile_overlay1")}}>
                                    <span className="clcdue M14_9e" id="child_det">CANCEL</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <UploadImgOverlay eleRef={this} tool={""}/>
                    <div className="childProfile_overlay2">
                        <div className="popup tbmargin">
                            <span className="close_icon icon right R14_9e" data-icon-font="C" onClick={() =>{ this.closechildPopup("childProfile_overlay2")}}></span>
                            <div className="agetext R14_42">This feature is available only for children in the age group 8 Months -24 Months</div>
                        </div>
                    </div>
                </div>
                <div className="new-right-sect">
                    {global.ftk && this.state.windowWidth >= 768 &&
                    <div className="desk_view">
                        { this.state.mealRecpData && this.state.mealRecpData.childid!='' ?
                        <div className="child_pro_cont">
                            <div id="slider" className="ui-card-slider four_child_slider">
                                {/* <div className="child_image">
                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/mob_baby.png" title="jui" className="dev_swap_pic" />
                                    <div className="edit-child" onClick={() =>{ this.onEditChild()}}><label className="icon dev_swap_pic" data-icon-font="H"></label></div>
                                    <div className="edit-child" onClick={() =>{ this.onEditChild()}}><label className="icon dev_swap_pic" data-icon-font="H"></label></div>
                                </div> */}
                                <div className="child_image" onClick={(e) =>{ this.onEditChild(e)}}>
                                            {global.ftk && this.state.mealRecpData && this.state.mealRecpData.childPhoto!='' ?
                                                <img src={this.state.mealRecpData.childPhoto} className="dev_swap_pic" alt="Baby Meal Planner" title="Baby Meal Planner" name="Baby Meal Planner"/>
                                                :
                                                <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/mob_baby.png" className="dev_swap_pic" alt="Baby Meal Planner" title="Baby Meal Planner" name="Baby Meal Planner"/>
                                                }
                                            {/* <?php if($count > 1) { ?> */}
                                                <div className="edit-child"><label className="icon dev_swap_pic" data-icon-font="H"></label></div>
                                            {/* <?php } ?>*/}
                                        </div>
                            </div>
                            {this.state.sliderData}
                        </div>
                        :
                        <div className="nonloggedIn">
                            <div className="more-info">
                                <div className="about-yourself">
                                    <span className="about-yourself-txt M15_42">Tell us more about yourself to get more Personalized Feed</span>
                                </div>
                                <div className="childprofile-container left">
                                    <ul className="child-container left">
                                        <li className="child-pic active" id="child_baby" onClick={() =>{ this.childDetails('0 to 2 yrs') }}>
                                            <div className="select-child">
                                                <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/baby_desk.png" className="dev_pic" />
                                            </div>
                                            <div className="edit-child" onClick={() =>{ this.childDetails('0 to 2 yrs') }}><label className="icon dev_swap_pic" data-icon-font="H"></label></div>
                                            <div className="tabs_cont">
                                                <span className="R14_42 dev_pic">Baby 0 to 2 yrs</span>
                                            </div>
                                        </li>
                                        <li className="child-pic" id="child_toddler" onClick={() =>{ this.childAgeDetails('2 to 4 yrs') }}>
                                            <div className="select-child">
                                                <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/toddler_desk.png" className="dev_pic" />
                                            </div>
                                            <div className="tabs_cont">
                                                <span className="R14_42 dev_pic">Toddler 2 to 4 yrs</span>
                                            </div>
                                        </li>
                                        <li className="child-pic" id="child_kid" onClick={() =>{ this.childAgeDetails('4+ yrs') }}>
                                            <div className="select-child">
                                                <div className="inner-circle"></div>
                                                <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/6yr_kid_desk.png" className="dev_pic" />
                                            </div>
                                            <div className="tabs_cont">
                                                <span className="R14_42 dev_pic">Kid 4+ yrs</span>
                                            </div>
                                        </li>
                                        <li className="child-pic" id="child_expecting">
                                        {this.state.isApp ?
                                            <a onClick={()=>{this.pregAppCall()}}>
                                                <div className="select-child">
                                                    <div className="inner-circle"></div>
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/expecting_desk.png" className="dev_pic" />
                                                </div>
                                                <div className="tabs_cont">
                                                    <span className="R14_42 dev_pic">Expecting</span>
                                                </div>
                                            </a>
                                        :
                                            <a href="https://parenting.firstcry.com/tools/pregnancy-diet-plan/">
                                                <div className="select-child">
                                                    <div className="inner-circle"></div>
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/expecting_desk.png" className="dev_pic" />
                                                </div>
                                                <div className="tabs_cont">
                                                    <span className="R14_42 dev_pic">Expecting</span>
                                                </div>
                                            </a>
                                        }
                                            
                                        </li>
                                        <li className="child-pic" id="child_conceive" onClick={() =>{ this.childAgeDetails('trytoconceivedet') }}>
                                            <div className="select-child">
                                                <div className="inner-circle"></div>
                                                <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/vector_smart_object_desk.png" />
                                            </div>
                                            <div className="tabs_cont">
                                                <span className="R14_42 dev_pic">Trying to Conceive</span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                    }   
                    <Right url={this.props.location.pathname} />
                </div>
            </main>
        )
    }
}

export default withContext(MealPlannerLanding);
